import React, { useContext, useEffect, useRef, useState } from "react";
import App from "../LayoutMobile";
import {
  Card,
  ConfigProvider,
  Divider,
  Form,
  message,
  Pagination,
  Checkbox,
  Popover,
  Table,
  Input,
  Select,
  Button,
  Space,
  Popconfirm,
  Tag,
  TimePicker,
  DatePicker,
  Typography,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  SwitcherOutlined,
  EyeOutlined,
  PlusOutlined,
  DownOutlined,
  CalendarOutlined,
  BankOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import { QuestionCircleOutlined } from "@ant-design/icons";
import "./CorporateProduct.css";
import axios from "axios";
import dayjs from "dayjs";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";
import { Config } from "../Common/Config";
import { customDropdown } from "../Common/CommonFunction";
const { Option } = Select;
const { TextArea } = Input;
const { Title } = Typography;

const CorporateProduct = () => {
  const MAX_CHARS = 250;
  const charCountRefs = useRef({});
  const editorRef = useRef(null);
  const [form] = Form.useForm();
  const [metaData, setmetaData] = useState(null);
  const [productCategoriesdataShow, setproductCategoriesdataShow] = useState(
    []
  );
  const [Allcategory, setAllcategory] = useState(null);
  // let { metaData } = useContext(AppContext),
  let showCategory = null;
  const navigate = useNavigate();
  // ── IOO-300: read category ID from URL so the right products are loaded ──
  const [searchParams] = useSearchParams();
  const categoryIdFromUrl = parseInt(searchParams.get('categoryId'), 10) || null;
  // console.log(':::metaData::', metaData)
  let showCategoryTemp = localStorage.getItem("showCategory");
  if (showCategoryTemp) {
    showCategory = JSON.parse(showCategoryTemp);
  }
  const [clinicDataSetInUpdate, setclinicDataSet] = useState({});
  const [allClinicData, setallClinicData] = useState([]);
  const [loader, setloader] = useState(false);
  const [CurrentPage, setCurrentPage] = useState(1);
  const [isClinicCreateEnable, setisClinicCreateEnable] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [showAddButton, setshowAddButton] = useState(true);
  const [editTextArea, seteditTextArea] = useState(null);
  const [showEditorOnlyAdd, setshowEditorOnlyAdd] = useState(true);
  const [AllLanguagesData, setAllLanguagesData] = useState([]);
  const [languageData, setlanguageData] = useState([]); //options
  const [prePayment, setPrePayment] = useState(false);
  const [eveningBooking, setEveningBooking] = useState(false);
  const [weekendBooking, setWeekendBooking] = useState(false);
  const [genderSelecttion, setGenderSelecttion] = useState(false);
  const [languageSelection, setLanguageSelection] = useState(false);
  const [bookingPageCopy, setbookingPageCopy] = useState([]);
  const [durationObjectById, setdurationObjectById] = useState(null);
  const [limit, setLimit] = useState(20)
  const [formMode, setFormMode] = useState('edit')
  const isViewMode = formMode === 'view'
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [searchText, setSearchText] = useState('');
  const searchDebounceRef = useRef(null);
  const hasFetched = useRef(false);

  // ── Availability config state ──────────────────────────────────────────────
  const [allClinicsForAvailability, setAllClinicsForAvailability] = useState([]);
  const DAYS_OF_WEEK = [
    { label: 'Monday',    value: 'monday' },
    { label: 'Tuesday',   value: 'tuesday' },
    { label: 'Wednesday', value: 'wednesday' },
    { label: 'Thursday',  value: 'thursday' },
    { label: 'Friday',    value: 'friday' },
    { label: 'Saturday',  value: 'saturday' },
    { label: 'Sunday',    value: 'sunday' },
  ];

  // 'all' = all clinics, 'specific' = per-clinic cards
  const [clinicMode, setClinicMode] = useState('all');

  // ── Per-clinic schedule factory & state ────────────────────────────────────
  const makeClinicSchedule = (uid) => ({
    uid,
    clinicIds: [],
    expanded: true,
    dayScheduleMode: 'all',
    allDaysTimes: [{ id: Date.now() + Math.random(), startTime: null, endTime: null, isWholeDay: true }],
    customDaysSelected: [],
    customDaysTimes: {
      monday:    [{ id: 1, startTime: null, endTime: null, isWholeDay: true }],
      tuesday:   [{ id: 1, startTime: null, endTime: null, isWholeDay: true }],
      wednesday: [{ id: 1, startTime: null, endTime: null, isWholeDay: true }],
      thursday:  [{ id: 1, startTime: null, endTime: null, isWholeDay: true }],
      friday:    [{ id: 1, startTime: null, endTime: null, isWholeDay: true }],
      saturday:  [{ id: 1, startTime: null, endTime: null, isWholeDay: true }],
      sunday:    [{ id: 1, startTime: null, endTime: null, isWholeDay: true }],
    },
    customDaysExtraDates: [],
    customDateRanges: [{ id: Date.now() + Math.random(), date: null, slots: [{ id: Date.now() + Math.random() + 1, startTime: null, endTime: null, isWholeDay: true }] }],
  });
  const [clinicSchedules, setClinicSchedules] = useState([makeClinicSchedule(Date.now())]);

  // Base updater
  const updateClinicCard = (uid, updater) =>
    setClinicSchedules((prev) => prev.map((c) => (c.uid === uid ? updater(c) : c)));

  // Clinic card CRUD
  const addClinicSchedule = () =>
    setClinicSchedules((prev) => [
      ...prev.map((c) => ({ ...c, expanded: false })),
      makeClinicSchedule(Date.now() + Math.random()),
    ]);
  const removeClinicSchedule = (uid) =>
    setClinicSchedules((prev) => prev.filter((c) => c.uid !== uid));
  const toggleClinicCard = (uid) =>
    setClinicSchedules((prev) =>
      prev.map((c) => ({ ...c, expanded: c.uid === uid ? !c.expanded : false }))
    );

  // Per-clinic: All-days helpers
  const clinicAddAllDaysSlot = (uid) =>
    updateClinicCard(uid, (c) => ({ ...c, allDaysTimes: [...c.allDaysTimes, { id: Date.now() + Math.random(), startTime: null, endTime: null, isWholeDay: false }] }));
  const clinicRemoveAllDaysSlot = (uid, slotId) =>
    updateClinicCard(uid, (c) => ({ ...c, allDaysTimes: c.allDaysTimes.filter((s) => s.id !== slotId) }));
  const clinicUpdateAllDaysSlot = (uid, slotId, field, val) =>
    updateClinicCard(uid, (c) => ({ ...c, allDaysTimes: c.allDaysTimes.map((s) => s.id === slotId ? { ...s, [field]: val } : s) }));
  const clinicToggleAllDaysWhole = (uid) =>
    updateClinicCard(uid, (c) => {
      const isOn = c.allDaysTimes.some((s) => s.isWholeDay);
      return { ...c, allDaysTimes: isOn ? [{ id: Date.now(), startTime: null, endTime: null, isWholeDay: false }] : [{ id: Date.now(), startTime: null, endTime: null, isWholeDay: true }] };
    });

  // Per-clinic: Custom-days helpers
  const clinicSetCustomDays = (uid, days) =>
    updateClinicCard(uid, (c) => {
      // For any newly added day, seed its customDaysTimes entry with isWholeDay:true
      const newTimes = { ...c.customDaysTimes };
      days.forEach((d) => {
        if (!newTimes[d] || newTimes[d].length === 0) {
          newTimes[d] = [{ id: Date.now() + Math.random(), startTime: null, endTime: null, isWholeDay: true }];
        }
      });
      return { ...c, customDaysSelected: days, customDaysTimes: newTimes };
    });
  const clinicAddCustomDaySlot = (uid, dayVal) =>
    updateClinicCard(uid, (c) => ({ ...c, customDaysTimes: { ...c.customDaysTimes, [dayVal]: [...(c.customDaysTimes[dayVal] || []), { id: Date.now() + Math.random(), startTime: null, endTime: null, isWholeDay: false }] } }));
  const clinicRemoveCustomDaySlot = (uid, dayVal, slotId) =>
    updateClinicCard(uid, (c) => ({ ...c, customDaysTimes: { ...c.customDaysTimes, [dayVal]: c.customDaysTimes[dayVal].filter((s) => s.id !== slotId) } }));
  const clinicUpdateCustomDayTime = (uid, dayVal, slotId, field, val) =>
    updateClinicCard(uid, (c) => ({ ...c, customDaysTimes: { ...c.customDaysTimes, [dayVal]: c.customDaysTimes[dayVal].map((s) => s.id === slotId ? { ...s, [field]: val } : s) } }));
  const clinicToggleCustomDayWhole = (uid, dayVal) =>
    updateClinicCard(uid, (c) => {
      const isOn = (c.customDaysTimes[dayVal] || []).some((s) => s.isWholeDay);
      return { ...c, customDaysTimes: { ...c.customDaysTimes, [dayVal]: isOn ? [{ id: Date.now(), startTime: null, endTime: null, isWholeDay: false }] : [{ id: Date.now(), startTime: null, endTime: null, isWholeDay: true }] } };
    });

  // Per-clinic: Custom-dates helpers
  const clinicAddCustomDateRow = (uid) =>
    updateClinicCard(uid, (c) => ({ ...c, customDateRanges: [...c.customDateRanges, { id: Date.now() + Math.random(), date: null, slots: [{ id: Date.now() + Math.random() + 1, startTime: null, endTime: null, isWholeDay: true }] }] }));
  const clinicRemoveCustomDateRow = (uid, rowId) =>
    updateClinicCard(uid, (c) => ({ ...c, customDateRanges: c.customDateRanges.filter((r) => r.id !== rowId) }));
  const clinicUpdateCustomDateRow = (uid, rowId, field, val) =>
    updateClinicCard(uid, (c) => ({ ...c, customDateRanges: c.customDateRanges.map((r) => r.id === rowId ? { ...r, [field]: val } : r) }));

  // Per-clinic: Custom-days extra dates
  const clinicAddExtraDate = (uid) =>
    updateClinicCard(uid, (c) => ({ ...c, customDaysExtraDates: [...(c.customDaysExtraDates || []), { id: Date.now() + Math.random(), date: null, slots: [{ id: Date.now() + Math.random() + 1, startTime: null, endTime: null, isWholeDay: true }] }] }));
  const clinicRemoveExtraDate = (uid, rowId) =>
    updateClinicCard(uid, (c) => ({ ...c, customDaysExtraDates: (c.customDaysExtraDates || []).filter((r) => r.id !== rowId) }));
  const clinicUpdateExtraDate = (uid, rowId, field, val) =>
    updateClinicCard(uid, (c) => ({ ...c, customDaysExtraDates: (c.customDaysExtraDates || []).map((r) => r.id === rowId ? { ...r, [field]: val } : r) }));

  // Per-clinic: Extra-date slot helpers
  const clinicAddExtraDateSlot = (uid, rowId) =>
    updateClinicCard(uid, (c) => ({ ...c, customDaysExtraDates: (c.customDaysExtraDates || []).map((r) => r.id === rowId ? { ...r, slots: [...(r.slots || []), { id: Date.now() + Math.random(), startTime: null, endTime: null, isWholeDay: false }] } : r) }));
  const clinicRemoveExtraDateSlot = (uid, rowId, slotId) =>
    updateClinicCard(uid, (c) => ({ ...c, customDaysExtraDates: (c.customDaysExtraDates || []).map((r) => r.id === rowId ? { ...r, slots: (r.slots || []).filter((s) => s.id !== slotId) } : r) }));
  const clinicUpdateExtraDateSlot = (uid, rowId, slotId, field, val) =>
    updateClinicCard(uid, (c) => ({ ...c, customDaysExtraDates: (c.customDaysExtraDates || []).map((r) => r.id === rowId ? { ...r, slots: (r.slots || []).map((s) => s.id === slotId ? { ...s, [field]: val } : s) } : r) }));
  const clinicToggleExtraDateWhole = (uid, rowId) =>
    updateClinicCard(uid, (c) => ({ ...c, customDaysExtraDates: (c.customDaysExtraDates || []).map((r) => {
      if (r.id !== rowId) return r;
      const isOn = (r.slots || []).some((s) => s.isWholeDay);
      return { ...r, slots: isOn ? [{ id: Date.now(), startTime: null, endTime: null, isWholeDay: false }] : [{ id: Date.now(), startTime: null, endTime: null, isWholeDay: true }] };
    }) }));

  // Per-clinic: Custom-date slot helpers
  const clinicAddCustomDateSlot = (uid, rowId) =>
    updateClinicCard(uid, (c) => ({ ...c, customDateRanges: c.customDateRanges.map((r) => r.id === rowId ? { ...r, slots: [...(r.slots || []), { id: Date.now() + Math.random(), startTime: null, endTime: null, isWholeDay: false }] } : r) }));
  const clinicRemoveCustomDateSlot = (uid, rowId, slotId) =>
    updateClinicCard(uid, (c) => ({ ...c, customDateRanges: c.customDateRanges.map((r) => r.id === rowId ? { ...r, slots: (r.slots || []).filter((s) => s.id !== slotId) } : r) }));
  const clinicUpdateCustomDateSlot = (uid, rowId, slotId, field, val) =>
    updateClinicCard(uid, (c) => ({ ...c, customDateRanges: c.customDateRanges.map((r) => r.id === rowId ? { ...r, slots: (r.slots || []).map((s) => s.id === slotId ? { ...s, [field]: val } : s) } : r) }));
  const clinicToggleCustomDateWhole = (uid, rowId) =>
    updateClinicCard(uid, (c) => ({ ...c, customDateRanges: c.customDateRanges.map((r) => {
      if (r.id !== rowId) return r;
      const isOn = (r.slots || []).some((s) => s.isWholeDay);
      return { ...r, slots: isOn ? [{ id: Date.now(), startTime: null, endTime: null, isWholeDay: false }] : [{ id: Date.now(), startTime: null, endTime: null, isWholeDay: true }] };
    }) }));

  // Day schedule mode for All-Clinics global schedule
  const [dayScheduleMode, setDayScheduleMode] = useState('all');

  // All-days mode: array of time slots
  const [allDaysTimes, setAllDaysTimes] = useState([
    { id: 1, startTime: null, endTime: null, isWholeDay: true },
  ]);
  const addAllDaysSlot = () =>
    setAllDaysTimes((prev) => [...prev, { id: Date.now() + Math.random(), startTime: null, endTime: null, isWholeDay: false }]);
  const removeAllDaysSlot = (id) =>
    setAllDaysTimes((prev) => prev.filter((s) => s.id !== id));
  const updateAllDaysSlot = (id, field, val) =>
    setAllDaysTimes((prev) => prev.map((s) => s.id === id ? { ...s, [field]: val } : s));
  const toggleAllDaysWhole = () =>
    setAllDaysTimes((prev) => {
      const isOn = prev.some((s) => s.isWholeDay);
      if (!isOn) return [{ id: Date.now(), startTime: null, endTime: null, isWholeDay: true }];
      return [{ id: Date.now(), startTime: null, endTime: null, isWholeDay: false }];
    });

  // Overlap / invalid-range checker
  const hasTimeOverlap = (slots) => {
    const valid = slots.filter((s) => !s.isWholeDay && s.startTime && s.endTime);
    for (let i = 0; i < valid.length; i++) {
      if (!valid[i].startTime.isBefore(valid[i].endTime)) return true;
      for (let j = i + 1; j < valid.length; j++) {
        if (valid[i].startTime.isBefore(valid[j].endTime) && valid[j].startTime.isBefore(valid[i].endTime)) return true;
      }
    }
    return false;
  };

  // Custom-days mode
  const [customDaysSelected, setCustomDaysSelected] = useState([]);
  const [customDaysTimes, setCustomDaysTimes] = useState({
    monday:    [{ id: 1, startTime: null, endTime: null, isWholeDay: true }],
    tuesday:   [{ id: 1, startTime: null, endTime: null, isWholeDay: true }],
    wednesday: [{ id: 1, startTime: null, endTime: null, isWholeDay: true }],
    thursday:  [{ id: 1, startTime: null, endTime: null, isWholeDay: true }],
    friday:    [{ id: 1, startTime: null, endTime: null, isWholeDay: true }],
    saturday:  [{ id: 1, startTime: null, endTime: null, isWholeDay: true }],
    sunday:    [{ id: 1, startTime: null, endTime: null, isWholeDay: true }],
  });
  const addCustomDaySlot = (dayValue) =>
    setCustomDaysTimes((prev) => ({ ...prev, [dayValue]: [...(prev[dayValue] || []), { id: Date.now() + Math.random(), startTime: null, endTime: null, isWholeDay: false }] }));
  const removeCustomDaySlot = (dayValue, id) =>
    setCustomDaysTimes((prev) => ({ ...prev, [dayValue]: (prev[dayValue] || []).filter((s) => s.id !== id) }));
  const updateCustomDayTime = (dayValue, slotId, field, val) =>
    setCustomDaysTimes((prev) => ({ ...prev, [dayValue]: (prev[dayValue] || []).map((s) => s.id === slotId ? { ...s, [field]: val } : s) }));
  const toggleCustomDayWhole = (dayValue) =>
    setCustomDaysTimes((prev) => {
      const daySlots = prev[dayValue] || [];
      const isOn = daySlots.some((s) => s.isWholeDay);
      if (!isOn) return { ...prev, [dayValue]: [{ id: Date.now(), startTime: null, endTime: null, isWholeDay: true }] };
      return { ...prev, [dayValue]: [{ id: Date.now(), startTime: null, endTime: null, isWholeDay: false }] };
    });

  // Custom-dates mode
  const [customDateRanges, setCustomDateRanges] = useState([
    { id: Date.now(), date: null, slots: [{ id: Date.now() + 1, startTime: null, endTime: null, isWholeDay: true }] },
  ]);
  const addCustomDateRow = () => {
    setCustomDateRanges((prev) => [
      ...prev,
      { id: Date.now() + Math.random(), date: null, slots: [{ id: Date.now() + Math.random() + 1, startTime: null, endTime: null, isWholeDay: true }] },
    ]);
  };
  const removeCustomDateRow = (id) => {
    setCustomDateRanges((prev) => prev.filter((r) => r.id !== id));
  };
  const updateCustomDateRow = (id, field, value) => {
    setCustomDateRanges((prev) =>
      prev.map((r) => (r.id === id ? { ...r, [field]: value } : r))
    );
  };
  const addCustomDateSlot = (rowId) =>
    setCustomDateRanges((prev) => prev.map((r) => r.id === rowId ? { ...r, slots: [...(r.slots || []), { id: Date.now() + Math.random(), startTime: null, endTime: null, isWholeDay: false }] } : r));
  const removeCustomDateSlot = (rowId, slotId) =>
    setCustomDateRanges((prev) => prev.map((r) => r.id === rowId ? { ...r, slots: (r.slots || []).filter((s) => s.id !== slotId) } : r));
  const updateCustomDateSlot = (rowId, slotId, field, val) =>
    setCustomDateRanges((prev) => prev.map((r) => r.id === rowId ? { ...r, slots: (r.slots || []).map((s) => s.id === slotId ? { ...s, [field]: val } : s) } : r));
  const toggleCustomDateWhole = (rowId) =>
    setCustomDateRanges((prev) => prev.map((r) => {
      if (r.id !== rowId) return r;
      const isOn = (r.slots || []).some((s) => s.isWholeDay);
      return { ...r, slots: isOn ? [{ id: Date.now(), startTime: null, endTime: null, isWholeDay: false }] : [{ id: Date.now(), startTime: null, endTime: null, isWholeDay: true }] };
    }));

  // Custom-days extra dates (one-off specific dates within Custom Days tab)
  const [customDaysExtraDates, setCustomDaysExtraDates] = useState([]);
  const addCustomDaysExtraDate = () =>
    setCustomDaysExtraDates((prev) => [...prev, { id: Date.now() + Math.random(), date: null, slots: [{ id: Date.now() + Math.random() + 1, startTime: null, endTime: null, isWholeDay: true }] }]);
  const removeCustomDaysExtraDate = (id) =>
    setCustomDaysExtraDates((prev) => prev.filter((r) => r.id !== id));
  const updateCustomDaysExtraDate = (id, field, value) =>
    setCustomDaysExtraDates((prev) => prev.map((r) => r.id === id ? { ...r, [field]: value } : r));
  const addCustomDaysExtraDateSlot = (rowId) =>
    setCustomDaysExtraDates((prev) => prev.map((r) => r.id === rowId ? { ...r, slots: [...(r.slots || []), { id: Date.now() + Math.random(), startTime: null, endTime: null, isWholeDay: false }] } : r));
  const removeCustomDaysExtraDateSlot = (rowId, slotId) =>
    setCustomDaysExtraDates((prev) => prev.map((r) => r.id === rowId ? { ...r, slots: (r.slots || []).filter((s) => s.id !== slotId) } : r));
  const updateCustomDaysExtraDateSlot = (rowId, slotId, field, val) =>
    setCustomDaysExtraDates((prev) => prev.map((r) => r.id === rowId ? { ...r, slots: (r.slots || []).map((s) => s.id === slotId ? { ...s, [field]: val } : s) } : r));
  const toggleCustomDaysExtraDateWhole = (rowId) =>
    setCustomDaysExtraDates((prev) => prev.map((r) => {
      if (r.id !== rowId) return r;
      const isOn = (r.slots || []).some((s) => s.isWholeDay);
      return { ...r, slots: isOn ? [{ id: Date.now(), startTime: null, endTime: null, isWholeDay: false }] : [{ id: Date.now(), startTime: null, endTime: null, isWholeDay: true }] };
    }));

  // ── Availability state reset / load / serialise helpers ────────────────────
  const resetAvailabilityState = () => {
    setClinicMode('all');
    setDayScheduleMode('all');
    setAllDaysTimes([{ id: 1, startTime: null, endTime: null, isWholeDay: true }]);
    setCustomDaysSelected([]);
    setCustomDaysTimes({
      monday:    [{ id: 1, startTime: null, endTime: null, isWholeDay: true }],
      tuesday:   [{ id: 1, startTime: null, endTime: null, isWholeDay: true }],
      wednesday: [{ id: 1, startTime: null, endTime: null, isWholeDay: true }],
      thursday:  [{ id: 1, startTime: null, endTime: null, isWholeDay: true }],
      friday:    [{ id: 1, startTime: null, endTime: null, isWholeDay: true }],
      saturday:  [{ id: 1, startTime: null, endTime: null, isWholeDay: true }],
      sunday:    [{ id: 1, startTime: null, endTime: null, isWholeDay: true }],
    });
    setCustomDaysExtraDates([]);
    setCustomDateRanges([{ id: Date.now(), date: null, slots: [{ id: Date.now() + 1, startTime: null, endTime: null, isWholeDay: true }] }]);
    setClinicSchedules([makeClinicSchedule(Date.now())]);
  };

  // Deserialises the `availability` JSON from a GET response into React state.
  // HARD RULE: if record.availability is falsy, returns early — defaults already applied.
  const loadAvailabilityFromRecord = (record) => {
    resetAvailabilityState();
    const a = record?.availability;
    if (!a) return;

    const clinic_mode = a.clinic_mode ?? a.clinicMode ?? 'all';
    setClinicMode(clinic_mode);

    if (clinic_mode === 'specific') {
      const schedules = a.clinic_schedules ?? a.clinicSchedules ?? [];
      if (Array.isArray(schedules) && schedules.length) {
        setClinicSchedules(
          schedules.map((cs, i) => {
            const dsm = cs.day_schedule_mode ?? cs.dayScheduleMode ?? 'all';
            const rawAllDaysTimes = cs.all_days_times ?? cs.allDaysTimes ?? [];
            const allDaysTimes = rawAllDaysTimes.map((s, j) => ({
              id: j + 1,
              isWholeDay: s.is_whole_day ?? s.isWholeDay ?? false,
              startTime: (s.start_time ?? s.startTime) ? dayjs((s.start_time ?? s.startTime), 'HH:mm') : null,
              endTime:   (s.end_time   ?? s.endTime)   ? dayjs((s.end_time   ?? s.endTime),   'HH:mm') : null,
            }));
            const customDaysSelected = cs.custom_days_selected ?? cs.customDaysSelected ?? [];
            const rawCustomDaysTimes = cs.custom_days_times ?? cs.customDaysTimes ?? {};
            const customDaysTimes = Object.fromEntries(
              Object.entries(rawCustomDaysTimes).map(([day, slots]) => [
                day,
                slots.map((s, j) => ({
                  id: j + 1,
                  isWholeDay: s.is_whole_day ?? s.isWholeDay ?? false,
                  startTime: (s.start_time ?? s.startTime) ? dayjs((s.start_time ?? s.startTime), 'HH:mm') : null,
                  endTime:   (s.end_time   ?? s.endTime)   ? dayjs((s.end_time   ?? s.endTime),   'HH:mm') : null,
                }))
              ])
            );
            let customDateRanges = [];
            if (cs.specific_dates_selected && cs.specific_dates_times) {
              customDateRanges = cs.specific_dates_selected.map((d, j) => {
                const slotArr = (cs.specific_dates_times[d] || []);
                return {
                  id: j + 1,
                  date: dayjs(d, 'YYYY-MM-DD'),
                  slots: slotArr.length ? slotArr.map((slot, k) => ({
                    id: k + 1,
                    isWholeDay: slot.is_whole_day ?? false,
                    startTime: slot.start_time ? dayjs(slot.start_time, 'HH:mm') : null,
                    endTime:   slot.end_time   ? dayjs(slot.end_time,   'HH:mm') : null,
                  })) : [{ id: 1, startTime: null, endTime: null, isWholeDay: false }],
                };
              });
            } else if (Array.isArray(cs.customDateRanges)) {
              customDateRanges = cs.customDateRanges.map((r, j) => ({
                id: j + 1,
                date: r.date ? dayjs(r.date, 'YYYY-MM-DD') : null,
                slots: (r.slots || [{ isWholeDay: r.isWholeDay ?? false, startTime: r.startTime, endTime: r.endTime }]).map((s, k) => ({
                  id: k + 1,
                  isWholeDay: s.isWholeDay ?? false,
                  startTime: s.startTime ? (typeof s.startTime === 'string' ? dayjs(s.startTime, 'HH:mm') : s.startTime) : null,
                  endTime:   s.endTime   ? (typeof s.endTime   === 'string' ? dayjs(s.endTime,   'HH:mm') : s.endTime)   : null,
                })),
              }));
            }
            const rawExtraDatesClinic = cs.custom_days_extra_dates ?? cs.customDaysExtraDates ?? [];
            const customDaysExtraDates = Array.isArray(rawExtraDatesClinic) && rawExtraDatesClinic.length
              ? rawExtraDatesClinic.map((r, k) => {
                  const rawSlots = r.slots || [r];
                  return {
                    id: k + 1,
                    date: r.date ? dayjs(r.date, 'YYYY-MM-DD') : null,
                    slots: rawSlots.map((s, si) => ({
                      id: si + 1,
                      isWholeDay: s.is_whole_day ?? s.isWholeDay ?? true,
                      startTime: s.start_time ? dayjs(s.start_time, 'HH:mm') : (s.startTime ? dayjs(s.startTime, 'HH:mm') : null),
                      endTime:   s.end_time   ? dayjs(s.end_time,   'HH:mm') : (s.endTime   ? dayjs(s.endTime,   'HH:mm') : null),
                    })),
                  };
                })
              : [];
            return {
              uid: Date.now() + i,
              expanded: i === 0,
              clinicIds: cs.clinic_ids ?? cs.clinicIds ?? [],
              dayScheduleMode: dsm,
              allDaysTimes: allDaysTimes.length ? allDaysTimes : [{ id: 1, startTime: null, endTime: null, isWholeDay: false }],
              customDaysSelected,
              customDaysTimes,
              customDaysExtraDates,
              customDateRanges: customDateRanges.length ? customDateRanges : [{ id: Date.now() + i, date: null, slots: [{ id: Date.now() + i + 1, startTime: null, endTime: null, isWholeDay: false }] }],
            };
          })
        );
      }
    } else {
      const dsm = a.day_schedule_mode ?? a.dayScheduleMode ?? 'all';
      setDayScheduleMode(dsm);
      const rawAllDaysTimes = a.all_days_times ?? a.allDaysTimes;
      if (rawAllDaysTimes) {
        setAllDaysTimes(rawAllDaysTimes.map((s, i) => ({
          id: i + 1,
          isWholeDay: s.is_whole_day ?? s.isWholeDay ?? false,
          startTime: (s.start_time ?? s.startTime) ? dayjs((s.start_time ?? s.startTime), 'HH:mm') : null,
          endTime:   (s.end_time   ?? s.endTime)   ? dayjs((s.end_time   ?? s.endTime),   'HH:mm') : null,
        })));
      }
      const selectedDays = a.custom_days_selected ?? a.customDaysSelected;
      if (selectedDays) setCustomDaysSelected(selectedDays);
      const rawCustomDaysTimes = a.custom_days_times ?? a.customDaysTimes;
      if (rawCustomDaysTimes) {
        setCustomDaysTimes(Object.fromEntries(
          Object.entries(rawCustomDaysTimes).map(([day, slots]) => [
            day,
            slots.map((s, j) => ({
              id: j + 1,
              isWholeDay: s.is_whole_day ?? s.isWholeDay ?? false,
              startTime: (s.start_time ?? s.startTime) ? dayjs((s.start_time ?? s.startTime), 'HH:mm') : null,
              endTime:   (s.end_time   ?? s.endTime)   ? dayjs((s.end_time   ?? s.endTime),   'HH:mm') : null,
            }))
          ])
        ));
      }
      // Extra dates within Custom Days tab
      const rawExtraDates = a.custom_days_extra_dates ?? a.customDaysExtraDates ?? [];
      if (Array.isArray(rawExtraDates) && rawExtraDates.length) {
        setCustomDaysExtraDates(rawExtraDates.map((r, i) => {
          const rawSlots = r.slots || [r];
          return {
            id: i + 1,
            date: r.date ? dayjs(r.date, 'YYYY-MM-DD') : null,
            slots: rawSlots.map((s, si) => ({
              id: si + 1,
              isWholeDay: s.is_whole_day ?? s.isWholeDay ?? true,
              startTime: s.start_time ? dayjs(s.start_time, 'HH:mm') : (s.startTime ? dayjs(s.startTime, 'HH:mm') : null),
              endTime:   s.end_time   ? dayjs(s.end_time,   'HH:mm') : (s.endTime   ? dayjs(s.endTime,   'HH:mm') : null),
            })),
          };
        }));
      } else {
        setCustomDaysExtraDates([]);
      }
      if (a.specific_dates_selected && a.specific_dates_times) {
        setCustomDateRanges(a.specific_dates_selected.map((d, i) => {
          const slotArr = (a.specific_dates_times[d] || []);
          return {
            id: i + 1,
            date: dayjs(d, 'YYYY-MM-DD'),
            slots: slotArr.length ? slotArr.map((slot, k) => ({
              id: k + 1,
              isWholeDay: slot.is_whole_day ?? false,
              startTime: slot.start_time ? dayjs(slot.start_time, 'HH:mm') : null,
              endTime:   slot.end_time   ? dayjs(slot.end_time,   'HH:mm') : null,
            })) : [{ id: 1, startTime: null, endTime: null, isWholeDay: false }],
          };
        }));
      } else if (Array.isArray(a.customDateRanges)) {
        setCustomDateRanges(a.customDateRanges.map((r, i) => ({
          id: i + 1,
          date: r.date ? dayjs(r.date, 'YYYY-MM-DD') : null,
          slots: (r.slots || [{ isWholeDay: r.isWholeDay ?? false, startTime: r.startTime, endTime: r.endTime }]).map((s, k) => ({
            id: k + 1,
            isWholeDay: s.isWholeDay ?? false,
            startTime: s.startTime ? (typeof s.startTime === 'string' ? dayjs(s.startTime, 'HH:mm') : s.startTime) : null,
            endTime:   s.endTime   ? (typeof s.endTime   === 'string' ? dayjs(s.endTime,   'HH:mm') : s.endTime)   : null,
          })),
        })));
      }
    }
  };

  // Serialises dayjs slots to plain API objects (snake_case)
  const serializeSlots = (slots) =>
    slots.map(({ isWholeDay, startTime, endTime }) => ({
      is_whole_day: isWholeDay,
      start_time: isWholeDay ? null : (startTime?.format('HH:mm') ?? null),
      end_time:   isWholeDay ? null : (endTime?.format('HH:mm')   ?? null),
    }));

  // Builds the full `availability` payload from current React state
  const buildAvailabilityPayload = () => {
    if (clinicMode === 'specific') {
      return {
        clinic_mode: 'specific',
        clinic_schedules: clinicSchedules.map((cs) => ({
          clinic_ids: cs.clinicIds,
          day_schedule_mode: cs.dayScheduleMode,
          ...(cs.dayScheduleMode === 'all' && {
            all_days_times: serializeSlots(cs.allDaysTimes),
          }),
          ...(cs.dayScheduleMode === 'custom' && {
            custom_days_selected: cs.customDaysSelected,
            custom_days_times: Object.fromEntries(
              cs.customDaysSelected.map((day) => [
                day, serializeSlots(cs.customDaysTimes[day] || [])
              ])
            ),
            ...((cs.customDaysExtraDates || []).filter(r => r.date).length > 0 && {
              custom_days_extra_dates: (cs.customDaysExtraDates || [])
                .filter(r => r.date)
                .map(r => ({
                  date: r.date.format('YYYY-MM-DD'),
                  slots: (r.slots || []).map(s => ({
                    is_whole_day: s.isWholeDay,
                    start_time: s.isWholeDay ? null : (s.startTime?.format('HH:mm') ?? null),
                    end_time:   s.isWholeDay ? null : (s.endTime?.format('HH:mm')   ?? null),
                  })),
                })),
            }),
          }),
          ...(cs.dayScheduleMode === 'dates' && {
            specific_dates_selected: cs.customDateRanges
              .filter((r) => r.date)
              .map((r) => r.date.format('YYYY-MM-DD')),
            specific_dates_times: Object.fromEntries(
              cs.customDateRanges
                .filter((r) => r.date)
                .map((r) => [
                  r.date.format('YYYY-MM-DD'),
                  (r.slots || []).map((s) => ({
                    is_whole_day: s.isWholeDay,
                    start_time: s.isWholeDay ? null : (s.startTime?.format('HH:mm') ?? null),
                    end_time:   s.isWholeDay ? null : (s.endTime?.format('HH:mm')   ?? null),
                  }))
                ])
            ),
          }),
        })),
      };
    }
    return {
      clinic_mode: 'all',
      day_schedule_mode: dayScheduleMode,
      ...(dayScheduleMode === 'all' && {
        all_days_times: serializeSlots(allDaysTimes),
      }),
      ...(dayScheduleMode === 'custom' && {
        custom_days_selected: customDaysSelected,
        custom_days_times: Object.fromEntries(
          customDaysSelected.map((day) => [
            day, serializeSlots(customDaysTimes[day] || [])
          ])
        ),
        ...(customDaysExtraDates.filter(r => r.date).length > 0 && {
          custom_days_extra_dates: customDaysExtraDates
            .filter(r => r.date)
            .map(r => ({
              date: r.date.format('YYYY-MM-DD'),
              slots: (r.slots || []).map(s => ({
                is_whole_day: s.isWholeDay,
                start_time: s.isWholeDay ? null : (s.startTime?.format('HH:mm') ?? null),
                end_time:   s.isWholeDay ? null : (s.endTime?.format('HH:mm')   ?? null),
              })),
            })),
        }),
      }),
      ...(dayScheduleMode === 'dates' && {
        specific_dates_selected: customDateRanges
          .filter((r) => r.date)
          .map((r) => r.date.format('YYYY-MM-DD')),
        specific_dates_times: Object.fromEntries(
          customDateRanges
            .filter((r) => r.date)
            .map((r) => [
              r.date.format('YYYY-MM-DD'),
              [{
                is_whole_day: r.isWholeDay,
                start_time: r.isWholeDay ? null : (r.startTime?.format('HH:mm') ?? null),
                end_time:   r.isWholeDay ? null : (r.endTime?.format('HH:mm')   ?? null),
              }]
            ])
        ),
      }),
    };
  };

  const getAllClinicsForAvailability = async () => {
    try {
      const response = await axios.get(`${Config.url}clinic?per_page=-1`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      const clinics = response?.data?.data?.data || [];
      setAllClinicsForAvailability(clinics.filter((c) => String(c.status) === '1'));
    } catch (error) {
      console.error('Failed to fetch clinic list for availability:', error);
    }
  };

  useEffect(() => {
    const fetchAll = async () => {
      await getAllMetaData();
      await getAllProductData(1);
      getAllClinicsForAvailability();
    };
    fetchAll();
  }, []);
  useEffect(() => {
    if (!hasFetched.current) {
      getAllCorporateProduct(CurrentPage);
      getAllLanguages();
      getAllBucketsBookingCopyData();
      hasFetched.current = true;
    }
  }, [CurrentPage]);

  // ── IOO-300: re-fetch product list when URL categoryId changes ────────────
  useEffect(() => {
    if (categoryIdFromUrl) {
      setCurrentPage(1);
      getAllCorporateProduct(1);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryIdFromUrl]);
  // useEffect(() => {
  //     getAllBucketsBookingCopyData()
  // }, [])
  const getAllMetaData = async () => {
    if (!localStorage.getItem("token")) return;
    try {
      const response = await axios.get(`${Config.urlLogin}/api/v1/meta-data`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: { category: "clinician_type" },
      });
      if (response?.data?.data && response?.data?.data.data) {
        setmetaData(response?.data?.data.data);
      }
    } catch (error) {
      console.log("error in get clinic data ::::", error);
    }
  };
  const getAllProductData = async (CurrentPage, searchValue = null) => {
    if (!localStorage.getItem("token")) {
      return;
    }
    try {
      // IOO-300: fetch all categories in one shot so sidebar always shows all
      const url = `${Config.url}product-category/page/1?per_page=-1`;
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const rawList = response?.data?.data?.data;
      if (rawList && rawList.length) {
        let category = {};
        rawList.forEach((cat) => {
          if (cat?.product_category_id) {
            category[`category${cat.product_category_id}`] = cat;
          }
        });
        if (category && Object.keys(category).length) {
          setAllcategory(category);
          const productCategoriesdataShowTemp = Object.values(category).map((data) => ({
            label: `${data.name}`,
            value: `${data.product_category_id}`,
          }));
          setproductCategoriesdataShow(productCategoriesdataShowTemp);
          setloader(false);
          localStorage.setItem("showCategory", JSON.stringify(category));
        }
      }
    } catch (error) {
      console.log("error in product-category ::::", error);
    }
  };
  const getAllCorporateProduct = async (page = 1, search = '') => {
    setloader(true);
    // IOO-300: use URL categoryId dynamically; fallback to 3 for backward compat
    const catId = categoryIdFromUrl || 3;
    try {
      const params = new URLSearchParams({
        product_category_id: catId,
        per_page: limit,
      });
      if (search && search.trim()) {
        params.set('search', search.trim());
      }
      const response = await axios.get(
        `${Config.url}non-gp-products/page/${page}?${params.toString()}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      // console.log(" data ::::", response?.data?.data);
      setallClinicData(response?.data?.data);
      setloader(false);
      hasFetched.current = false;
    } catch (error) {
      console.log("error in get data ::::", error);
      messageApi.error({
        type: "error",
        content:
          error.response?.data?.message ||
          error.message ||
          "Something went wrong",
      });
      setloader(false);
    }
  };
  const getAllLanguages = async () => {
    try {
      let url = `${Config.url}languages`;

      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      // console.log('response getAllLanguages ::::', response.data.data.data)
      let languageData = [],
        objbyid = {};
      if (
        response &&
        response.data &&
        response.data.data &&
        response.data.data.data
      ) {
        response.data.data.data.map((lan) => {
          languageData.push({
            label: lan.language_name,
            value: lan.language_id,
          });
          objbyid[lan.language_id] = lan.language_name;
        });
        setAllLanguagesData(objbyid);
        setlanguageData(languageData);
      }
    } catch (error) {
      console.log("error in getAllLanguages ::::", error);
      messageApi.error({
        type: "error",
        content:
          error.response?.data?.message ||
          error.message ||
          "Something went wrong",
      });
      setloader(false);
    }
    setloader(false);
  };
  const getAllBucketsBookingCopyData = async () => {
    setloader(true);
    try {
      const response = await axios.get(`${Config.url}duration`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (response?.data?.data) {
        // console.log(':::response?.data?.data::::::', response?.data?.data)
        let durationObject = {};
        if (response?.data?.data && response?.data?.data.length) {
          response?.data?.data.map((duration) => {
            durationObject[duration.duration_id] = duration;
          });
        }
        // console.log(':::durationObject::::::', durationObject)
        setbookingPageCopy(response?.data?.data?.data);
        setdurationObjectById(durationObject);
        hasFetched.current = false;
      } else {
      }
      setloader(false);
    } catch (error) {
      console.log("error in get clinic-bucket-pricing data ::::", error);
      messageApi.error({
        type: "error",
        content:
          error.response?.data?.message ||
          error.message ||
          "Something went wrong",
      });
      setloader(false);
    }
  };
  const columns = [
    {
      title: "ID",
      dataIndex: "non_gp_product_id",
      key: "non_gp_product_id",
      render: (_, record) => (
        <div style={{ textAlign: "center" }}>{record.non_gp_product_id}</div>
      ),
    },
    {
      title: (
        <div className="table-title" style={{ textAlign: "left !important" }}>
          Name
        </div>
      ),
      dataIndex: "name",
      key: "name",
      render: (_, record) => (
        <div style={{ textAlign: "left !important" }}>{record.name}</div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (_, record) => (record?.status == 1 ? "Active" : "Inactive"),
    },
    {
      title: "",
      key: "action",
      render: (_, record) => (
        <div style={{ textAlign: 'right', marginRight: 2 }} onClick={(e) => e.stopPropagation()}>
          <Popover
            placement="left"
            trigger="click"
            content={() => content(record)}
          >
            <button
              onClick={(e) => e.stopPropagation()}
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                fontWeight: 700, fontSize: 18, letterSpacing: 2,
                color: '#008385', padding: '0 6px', lineHeight: 1,
              }}
            >···</button>
          </Popover>
        </div>
      ),
    },
  ];

  const content = (record) => {
    return (
      <div className="rule-action-popover" style={{ display: 'flex', flexDirection: 'column', padding: '4px 0' }}>
        <div
          className="rule-action-item"
          style={{ color: '#008385' }}
          onClick={(e) => {
            e.stopPropagation()
            setFormMode('view');
            setshowAddButton(false);
            setisClinicCreateEnable(true);
            setloader(true);
            if (record && record.clinicians?.length == 0) {
              record.clinicians = [{ type: null, duration: null }];
            }
            setPrePayment(record?.pre_payment_enabled);
            setEveningBooking(record?.allow_evening_booking);
            setWeekendBooking(record?.allow_weekend_booking);
            setGenderSelecttion(record?.allow_gender_selection);
            setLanguageSelection(record?.allow_language_selection);
            form.setFieldsValue(record);
            form.setFieldsValue({
              ...record,
              language_selection:
                AllLanguagesData && AllLanguagesData[record.language_selection]
                  ? {
                      value: record.language_selection,
                      label: AllLanguagesData[record.language_selection],
                    }
                  : record.language_selection,
            });
            setclinicDataSet(record);
            loadAvailabilityFromRecord(record);
            setloader(false);
            setshowEditorOnlyAdd(false);
            document.querySelector('.clinicCreate-form')?.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          <EyeOutlined style={{ fontSize: 15 }} /> View
        </div>
        <div
          className="rule-action-item"
          style={{ color: '#008385' }}
          onClick={(e) => {
            e.stopPropagation()
            setFormMode('edit');
            setshowAddButton(false);
            setisClinicCreateEnable(true);
            setloader(true);
            if (record && record.clinicians?.length == 0) {
              record.clinicians = [{ type: null, duration: null }];
            }
            setPrePayment(record?.pre_payment_enabled);
            setEveningBooking(record?.allow_evening_booking);
            setWeekendBooking(record?.allow_weekend_booking);
            setGenderSelecttion(record?.allow_gender_selection);
            setLanguageSelection(record?.allow_language_selection);
            form.setFieldsValue(record);
            form.setFieldsValue({
              ...record,
              language_selection:
                AllLanguagesData && AllLanguagesData[record.language_selection]
                  ? {
                      value: record.language_selection,
                      label: AllLanguagesData[record.language_selection],
                    }
                  : record.language_selection,
            });
            setclinicDataSet(record);
            loadAvailabilityFromRecord(record);
            setloader(false);
            setshowEditorOnlyAdd(false);
            document.querySelector('.clinicCreate-form')?.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          <EditOutlined style={{ fontSize: 15 }} /> Edit
        </div>
        <div className="rule-action-divider" />
        <Popconfirm
          title="Update status"
          description="Are you sure you want to update status?"
          onConfirm={() => updateStatus(record)}
          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
          okButtonProps={{ className: 'confirmation-popup-ok-button' }}
          cancelButtonProps={{ className: 'confirmation-popup-cancel-button' }}
          okText="Yes"
          cancelText="No"
        >
          <div className="rule-action-item" style={{ color: '#008385' }}>
            <SwitcherOutlined style={{ fontSize: 15 }} />
            {record && record.status == 1 ? ' Make Inactive' : ' Make Active'}
          </div>
        </Popconfirm>
        <div className="rule-action-divider" />
        <Popconfirm
          title="Delete"
          description="Are you sure you want to delete?"
          onConfirm={() => deleteUser(record)}
          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
          okButtonProps={{ className: 'confirmation-popup-ok-button' }}
          cancelButtonProps={{ className: 'confirmation-popup-cancel-button' }}
          okText="Yes, Delete"
          cancelText="Cancel"
        >
          <div className="rule-action-item rule-action-item--delete">
            <DeleteOutlined style={{ fontSize: 15 }} /> Delete
          </div>
        </Popconfirm>
      </div>
    );
  };
  const handleTableRowClick = (record) => {
    setFormMode('view');
    setshowAddButton(false);
    setisClinicCreateEnable(true);
    setloader(true);
    if (record && record.clinicians?.length == 0) {
      record.clinicians = [{ type: null, duration: null }];
    }
    form.setFieldsValue(record);
    setPrePayment(record?.pre_payment_enabled);
    setEveningBooking(record?.allow_evening_booking);
    setWeekendBooking(record?.allow_weekend_booking);
    setGenderSelecttion(record?.allow_gender_selection);
    setLanguageSelection(record?.allow_language_selection);
    form.setFieldsValue({
      ...record,
      language_selection:
        AllLanguagesData && AllLanguagesData[record.language_selection]
          ? {
              value: record.language_selection,
              label: AllLanguagesData[record.language_selection],
            }
          : record.language_selection,
    });
    setclinicDataSet(record);
    loadAvailabilityFromRecord(record);
    setloader(false);
    setshowEditorOnlyAdd(false);
    document
      .querySelector(".clinicCreate-form")
      ?.scrollIntoView({ behavior: "smooth" });
  };
  const updateStatus = async (record) => {
    if (!record?.non_gp_product_id) {
      return;
    }
    setloader(true);
    let url = `${Config.url}corporate-products/${record.non_gp_product_id}`;
    try {
      const response = await axios.put(
        url,
        {
          status: record.status == 1 ? 0 : 1,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      // console.log(' Successful:', response);

      messageApi.success({
        type: "succes",
        content: "Product status updated successfully",
      });
      setloader(false);
      getAllCorporateProduct(CurrentPage);
    } catch (error) {
      messageApi.error({
        type: "error",
        content: "Something Went wrong",
      });
      console.log("update user:", error.response?.data || error.message);
      // throw error;
    }
    setloader(false);
  };
  const deleteUser = async (record) => {
    let url = `${Config.url}non-gp-products/${record.non_gp_product_id}`;
    try {
      const response = await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      messageApi.success({
        type: "succes",
        content: "Product deleted successfully",
      });
      getAllCorporateProduct(CurrentPage);
    } catch (error) {
      messageApi.error({
        type: "error",
        content:
          error.response?.data?.message || error.message
            ? error.response?.data?.message || error.message
            : "Something went Wrong",
      });
      console.log("update :", error.response?.data?.message || error.message);
    }
  };
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a style={{ color: "#4A4A4A" }}>Previous</a>;
    }
    if (type === "next") {
      return <a style={{ color: "#4A4A4A" }}>Next</a>;
    }
    return originalElement;
  };
  const onFinish = async (values, update = false) => {
    // console.log("onFinish::::", values);
    if (
      values.language_selection &&
      values?.language_selection &&
      values.language_selection?.label
    ) {
      values.language_selection = values.language_selection?.value ?? 1;
    }
    // return
    // if (!clinicDataSetInUpdate?.product_specific_booking_page_long_copy) {
    //   messageApi.error({
    //     type: "error",
    //     content: "Product specific booking page long copy - Desktop",
    //   });
    //   return;
    // } else 
    //   if (
    //   !clinicDataSetInUpdate?.product_specific_booking_page_short_copy
    // ) {
    //   messageApi.error({
    //     type: "error",
    //     content: "Product specific booking page short copy - Mobile",
    //   });
    //   return;
    // } else 
      if (
      !clinicDataSetInUpdate?.specific_booking_confirmation_email_copy
    ) {
      messageApi.error({
        type: "error",
        content: "Product specific booking confirmation email copy",
      });
      return;
    } else if (!clinicDataSetInUpdate?.specific_booking_confirmation_sms_copy) {
      messageApi.error({
        type: "error",
        content: "Product specific booking confirmation sms copy",
      });
      return;
    }
    // Availability time-slot validation — do NOT call API if any error is visible
    const hasAvailabilityErrors = () => {
      const isInvalidSlots = (slots) => {
        if (!slots || slots.length === 0) return true;
        return slots.some(s => !s.isWholeDay && (!s.startTime || !s.endTime)) || hasTimeOverlap(slots);
      };

      const hasDuplicateDates = (rows) => {
        if (!rows || rows.length <= 1) return false;
        const dateStrings = rows
          .filter(r => r && r.date)
          .map(r => r.date.format('YYYY-MM-DD'));
        return new Set(dateStrings).size !== dateStrings.length;
      };

      if (clinicMode === 'specific') {
        if (!clinicSchedules || clinicSchedules.length === 0) return true;
        return clinicSchedules.some((cs) => {
          if (!cs.clinicIds || cs.clinicIds.length === 0) return true;
          
          if (cs.dayScheduleMode === 'all') return isInvalidSlots(cs.allDaysTimes);
          if (cs.dayScheduleMode === 'custom') {
            if (!cs.customDaysSelected || cs.customDaysSelected.length === 0) return true;
            if (cs.customDaysSelected.some((day) => isInvalidSlots(cs.customDaysTimes[day]))) return true;
            if (cs.customDaysExtraDates && cs.customDaysExtraDates.length > 0) {
              if (hasDuplicateDates(cs.customDaysExtraDates)) return true;
              return cs.customDaysExtraDates.some(row => !row.date || isInvalidSlots(row.slots));
            }
            return false;
          }
          if (cs.dayScheduleMode === 'dates') {
            if (!cs.customDateRanges || cs.customDateRanges.length === 0) return true;
            if (hasDuplicateDates(cs.customDateRanges)) return true;
            return cs.customDateRanges.some(row => !row.date || isInvalidSlots(row.slots));
          }
          return false;
        });
      }
      
      if (dayScheduleMode === 'all') return isInvalidSlots(allDaysTimes);
      if (dayScheduleMode === 'custom') {
        if (!customDaysSelected || customDaysSelected.length === 0) return true;
        if (customDaysSelected.some((day) => isInvalidSlots(customDaysTimes[day]))) return true;
        if (customDaysExtraDates && customDaysExtraDates.length > 0) {
           if (hasDuplicateDates(customDaysExtraDates)) return true;
           return customDaysExtraDates.some(row => !row.date || isInvalidSlots(row.slots));
        }
        return false;
      }
      if (dayScheduleMode === 'dates') {
        if (!customDateRanges || customDateRanges.length === 0) return true;
        if (hasDuplicateDates(customDateRanges)) return true;
        return customDateRanges.some(row => !row.date || isInvalidSlots(row.slots));
      }
      return false;
    };
    if (hasAvailabilityErrors()) {
      messageApi.error({
        type: 'error',
        content: 'Please fix the time slot errors (overlapping or invalid times) before saving.',
      });
      return;
    }
    // return
    setIsSubmitting(true);
    try {
      if (!update) {
        let url = `${Config.url}non-gp-products`,
          clinicians = [];
        let payload = {
          ...values,
          allow_evening_booking: eveningBooking,
          allow_weekend_booking: weekendBooking,
          pre_payment_enabled: prePayment,
          cancellations_rescheduling_restrictions: "Yes",
          product_category_id: 3,
          status: 1,
          availability: buildAvailabilityPayload(),
          product_specific_booking_page_long_copy:
            clinicDataSetInUpdate?.product_specific_booking_page_long_copy
              ? clinicDataSetInUpdate?.product_specific_booking_page_long_copy
              : undefined,
          product_specific_booking_page_short_copy:
            clinicDataSetInUpdate?.product_specific_booking_page_short_copy
              ? clinicDataSetInUpdate?.product_specific_booking_page_short_copy
              : undefined,
          specific_booking_confirmation_email_copy:
            clinicDataSetInUpdate?.specific_booking_confirmation_email_copy
              ? clinicDataSetInUpdate?.specific_booking_confirmation_email_copy
              : undefined,
          specific_booking_confirmation_sms_copy:
            clinicDataSetInUpdate?.specific_booking_confirmation_sms_copy
              ? clinicDataSetInUpdate?.specific_booking_confirmation_sms_copy
              : undefined,
        };
        if (values && values.clinicians && values.clinicians.length) {
          values.clinicians.map((room) => {
            clinicians.push({
              type: room.type,
              duration: room.duration,
            });
          });
          if (clinicians && clinicians.length) {
            payload = {
              ...payload,
              clinicians,
            };
          }
        }
        // console.log("payload", { url, payload });
        // return
        const response = await axios.post(url, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        // console.log("response", response);
        if (response?.data?.success) {
          form.setFieldsValue({
            name: "",
            price: '"150"',
            pre_payment_amt: "",
            cancellations_rescheduling_restrictions: "",
            min_booking_period_days: "",
            override_spacers: "",
            max_wait_slots_between_clinicians: "",
            clinicians: [],
            gender_selection: "",
            language_selection: "",
            semble_product_id: "",
          });
          setclinicDataSet({});
          setloader(false);
          setIsSubmitting(false);
          setFormMode('edit');
          resetAvailabilityState();
          getAllCorporateProduct(CurrentPage);
          setPrePayment(false);
          setEveningBooking(false);
          setWeekendBooking(false);
          setGenderSelecttion(false);
          setLanguageSelection(false);
          setCurrentPage(1);
          setshowAddButton(true);
          setisClinicCreateEnable(false); // I.2: only hide form on success
          messageApi.success({
            type: "succes",
            content: "Product added successfully",
          });
        }
      } else {
        if (!clinicDataSetInUpdate.non_gp_product_id) {
          setloader(false);
          return;
        }

        let url = `${Config.url}non-gp-products/${clinicDataSetInUpdate.non_gp_product_id}`,
          clinicians = [];
        let payload = {
          ...values,
          allow_evening_booking: eveningBooking,
          allow_weekend_booking: weekendBooking,
          pre_payment_enabled: prePayment,
          cancellations_rescheduling_restrictions: "Yes",
          product_category_id: 3,
          availability: buildAvailabilityPayload(),
          product_specific_booking_page_long_copy:
            clinicDataSetInUpdate?.product_specific_booking_page_long_copy
              ? clinicDataSetInUpdate?.product_specific_booking_page_long_copy
              : undefined,
          product_specific_booking_page_short_copy:
            clinicDataSetInUpdate?.product_specific_booking_page_short_copy
              ? clinicDataSetInUpdate?.product_specific_booking_page_short_copy
              : undefined,
          specific_booking_confirmation_email_copy:
            clinicDataSetInUpdate?.specific_booking_confirmation_email_copy
              ? clinicDataSetInUpdate?.specific_booking_confirmation_email_copy
              : undefined,
          specific_booking_confirmation_sms_copy:
            clinicDataSetInUpdate?.specific_booking_confirmation_sms_copy
              ? clinicDataSetInUpdate?.specific_booking_confirmation_sms_copy
              : undefined,
        };
        if (values && values.clinicians && values.clinicians.length) {
          values.clinicians.map((room) => {
            clinicians.push({
              type: room.type,
              duration: room.duration,
            });
          });
          if (clinicians && clinicians.length) {
            payload = {
              ...payload,
              clinicians,
            };
          }
        }
        const response = await axios.put(url, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setloader(true);
        if (response?.data?.success) {
          form.setFieldsValue({
            name: "",
            price: "",
            pre_payment_amt: "",
            cancellations_rescheduling_restrictions: "",
            min_booking_period_days: "",
            override_spacers: "",
            max_wait_slots_between_clinicians: "",
            clinicians: [],
            gender_selection: "",
            language_selection: "",
            semble_product_id: "",
          });
          setclinicDataSet({});
          setloader(false);
          setIsSubmitting(false);
          setFormMode('edit');
          resetAvailabilityState();
          getAllCorporateProduct(CurrentPage);
          seteditTextArea(null);
          setPrePayment(false);
          setEveningBooking(false);
          setWeekendBooking(false);
          setGenderSelecttion(false);
          setLanguageSelection(false);
          setCurrentPage(1);
          setshowAddButton(true);
          setisClinicCreateEnable(false); // I.2: only hide form on success
          messageApi.success({
            type: "succes",
            content: "Product updated successfully",
          });
        }
      }
    } catch (error) {
      setIsSubmitting(false);
      setloader(false);
      console.log(":error:::", error);
      if (error.response?.status === 422) {
        const errors = error.response?.data?.errors;
        const messages = errors
          ? Object.values(errors).flat().join('\n')
          : (error.response?.data?.message ?? 'Validation failed. Please review your availability configuration.');
        messageApi.error({ content: messages, duration: 8 });
      } else {
        messageApi.error({
          content: error.response?.data?.message ?? error.message ?? "Something went wrong",
        });
      }
    } // end catch — form stays open (isClinicCreateEnable unchanged)
    // I.2: Do NOT call setisClinicCreateEnable(false) here — that would hide the
    // form on error, leaving the user with no way to retry or cancel.
    setloader(false);
  };
  const layout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 16,
    },
  };
  const onChangePrepayment = (e) => {
    setPrePayment(e.target.checked);
  };
  const onChangeEveningBooking = (e) => {
    setEveningBooking(e.target.checked);
  };
  const onChangeWeekendBooking = (e) => {
    setWeekendBooking(e.target.checked);
  };
  // const onChangeGender = (e) => {
  //   setGenderSelecttion(e.target.value);
  // };
  // const onChangeLanguage = (e) => {
  //   setLanguageSelection(e.target.value);
  // };
  return (
    <App>
      {contextHolder}
      <div style={{ display: "grid", justifyContent: "center" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 15,
          }}
        >
          {allClinicData && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: 950,
                gap: 16,
              }}
            >
              <Title
                level={5}
                style={{ margin: 0, color: "#008385", fontSize: 20, whiteSpace: 'nowrap' }}
              >
                All products in the category{" "}
                <span style={{ color: "black", fontWeight: "400" }}>
                  ({allClinicData?.total ? allClinicData.total : "00"})
                </span>
              </Title>

              {/* ── Server-side search ── */}
              <Input.Search
                placeholder="Search products..."
                allowClear
                value={searchText}
                style={{ width: 260, height: 36 }}
                onChange={(e) => {
                  const val = e.target.value;
                  setSearchText(val);
                  clearTimeout(searchDebounceRef.current);
                  searchDebounceRef.current = setTimeout(() => {
                    setCurrentPage(1);
                    getAllCorporateProduct(1, val);
                  }, 400);
                }}
                onSearch={(val) => {
                  clearTimeout(searchDebounceRef.current);
                  setCurrentPage(1);
                  getAllCorporateProduct(1, val);
                }}
              />
            </div>
          )}
          {/* <Select
                        placeholder="Health screens"
                        style={{ width: "215px", height: 40 }}
                        allowClear
                        defaultValue={'health_screens'}
                        onSelect={(value) => {
                            // console.log(':::::::::::::::', value)
                            if (value && value == 'gp_appointment') {
                                navigate('/gp-product-admin')
                            }
                        }}
                    >
                        <Option value="health_screens">{productCategoriesdataShow && productCategoriesdataShow.category2 && productCategoriesdataShow.category2?.name ? productCategoriesdataShow.category2.name : 'Health screens'}</Option>
                        <Option value="gp_appointment">{productCategoriesdataShow && productCategoriesdataShow.category1 && productCategoriesdataShow.category1?.name ? productCategoriesdataShow.category1.name : 'GP Appointments'}</Option>
                    </Select> */}
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Card
            className="addClinic-table"
            style={{
              width: 950,
              margin: 0,
              padding: 0,
              borderRadius: 50,
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
            }}
          >
            <ConfigProvider
              theme={{
                components: {
                  Table: {
                    headerBg: "#008385",
                    headerColor: "#ffffff",
                  },
                  Spin: {
                    colorPrimary: "#008385", // Change this to your desired color
                  },
                },
              }}
            >
              {allClinicData && (
                <Table
                  loading={loader}
                  columns={columns}
                  dataSource={allClinicData?.data}
                  pagination={false}
                  scroll={{
                    x: "auto",
                    // y: 330,
                  }}
                  onRow={(record) => ({
                    onClick: () => handleTableRowClick(record),
                  })}
                  // style={{ height: 367 }}
                />
              )}
              {allClinicData && allClinicData?.total ? (
                 <Pagination
                                align="center"
                                // defaultCurrent={1}
                                // defaultPageSize={20}
                                pageSize={limit}
                                className="corporate-customer-pagination"
                                total={allClinicData?.total || 0}
                                style={{ marginTop: 10 }}
                                current={CurrentPage}
                                onChange={(page, size) => {
                                  setCurrentPage(page);
                                  setLimit(size || 10);
                                  getAllCorporateProduct(page, searchText);
                                }}
                                itemRender={itemRender}
                              />
              ) : (
                ""
              )}
            </ConfigProvider>
          </Card>
        </div>
      </div>
      {showAddButton && (
        <div
          className="clinicCreate-form button-add-left"
          style={{
            display: "flex",
            justifyContent: "flex-start",
            marginTop: 20,
          }}
        >
          <Button
            className="add-generic-btn"
            onClick={() => {
              form.setFieldsValue({
                name: "",
                price: "",
                cancellations_rescheduling_restrictions: "No",
                min_booking_period_days: "",
                override_spacers: "No",
                max_wait_slots_between_clinicians: "0",
                clinicians: [{ type: null, duration: null }],
                gender_selection: "no_preference",
                language_selection: { values: 1, label: "English" },
              });
              setclinicDataSet({});
              setisClinicCreateEnable(true);
              setshowEditorOnlyAdd(true);
            }}
          >
            Add a product
          </Button>
        </div>
      )}
      {isClinicCreateEnable && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 20,
            padding: 20,
          }}
        >
          {/* Left Side - Clinic Form ,textAlign : 'left' */}
          <Card
            title={isViewMode ? "View Product Details" : "Product details"}
            className={isViewMode ? "productcategory-form view-mode-card" : "productcategory-form"}
            style={{ width: 470, height: "fit-content" }}
          >
            {clinicDataSetInUpdate && loader == false && (
              <Form
                form={form}
                // {...layout}
                // layout="vertical"
                initialValues={
                  clinicDataSetInUpdate ? clinicDataSetInUpdate : null
                }
                //
                onFinish={(values) =>
                  onFinish(
                    values,
                    clinicDataSetInUpdate &&
                      clinicDataSetInUpdate.non_gp_product_id &&
                      Object.keys(clinicDataSetInUpdate)?.length
                      ? true
                      : false
                  )
                }
              >
                {/* Name field */}
                <div
                  style={{ display: "flex", justifyContent: "space-between", marginTop: isViewMode ? 0 : 14, alignItems: 'center' }}
                  className={isViewMode ? 'view-detail-row' : ''}
                >
                  <label>Name:</label>
                  {isViewMode ? (
                    <span className="view-field-value" style={{ width: 174, display: 'inline-flex', alignItems: 'center' }}>{form.getFieldValue('name') || clinicDataSetInUpdate?.name || '-'}</span>
                  ) : (
                    <Form.Item name="name" rules={[{ required: !isViewMode, message: "Name is required." }]} style={{ marginBottom: 0, width: '100%' }}>
                      <Input placeholder="Name" />
                    </Form.Item>
                  )}
                </div>


                {/* Price + Bill to patient — same row (edit) */}
                {isViewMode ? (
                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: 0, alignItems: 'center' }} className="view-detail-row">
                    <label>Price:</label>
                    <span className="view-field-value" style={{ width: 174, display: 'inline-flex', alignItems: 'center' }}>{form.getFieldValue('price') || clinicDataSetInUpdate?.price || '-'}</span>
                  </div>
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginTop: 8 }}>
                    <label style={{ flexShrink: 0, marginBottom: 0 }}>Price:</label>
                    <Form.Item name="price" rules={[{ required: !isViewMode, message: "Price is required." }, { pattern: /^\d+(\.\d{1,2})?$/, message: "Enter a valid number (e.g., 10 or 10.99)" }]} style={{ marginBottom: 0 }}>
                      <Input prefix="£" style={{ width: 100 }} placeholder="0.00" />
                    </Form.Item>
                    <Form.Item name="pre_payment_enabled" style={{ marginBottom: 0 }}>
                      <Checkbox checked={prePayment} onChange={onChangePrepayment}>Bill to patient</Checkbox>
                    </Form.Item>
                  </div>
                )}

                {/* Bill to patient — view mode row */}
                {isViewMode && (
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }} className="view-detail-row">
                    <label>Bill to patient:</label>
                    <span className="view-field-value" style={{ width: 174, display: 'inline-flex', alignItems: 'center' }}>{prePayment ? 'Yes' : 'No'}</span>
                  </div>
                )}

                {/* Allow evening + Allow weekend — same row (edit) */}
                {isViewMode ? (
                  <>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }} className="view-detail-row">
                      <label>Allow evening booking:</label>
                      <span className="view-field-value" style={{ width: 174, display: 'inline-flex', alignItems: 'center' }}>{eveningBooking ? 'Yes' : 'No'}</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }} className="view-detail-row">
                      <label>Allow weekend booking:</label>
                      <span className="view-field-value" style={{ width: 174, display: 'inline-flex', alignItems: 'center' }}>{weekendBooking ? 'Yes' : 'No'}</span>
                    </div>
                  </>
                ) : (
                  <div style={{ display: 'flex', gap: 16, marginTop: 8 }}>
                    <Form.Item name="allow_evening_booking" style={{ marginBottom: 4 }}>
                      <Checkbox checked={eveningBooking} onChange={onChangeEveningBooking}>Allow evening bookings</Checkbox>
                    </Form.Item>
                    <Form.Item name="allow_weekend_booking" style={{ marginBottom: 4 }}>
                      <Checkbox checked={weekendBooking} onChange={onChangeWeekendBooking}>Allow weekend bookings</Checkbox>
                    </Form.Item>
                  </div>
                )}

                {/* <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                  className="minbookingperiod"
                >
                  <label>Cancellation & rescheduling restrictions:</label>
                  <Form.Item
                    name="cancellations_rescheduling_restrictions"
                    initialValues={{
                      cancellations_rescheduling_restrictions: true,
                    }}
                    rules={[
                      {
                        required: true,
                        message:
                          "Cancellation & Rescheduling selection is required.",
                      },
                    ]}
                  >
                    <Select
                      style={{ width: 71, height: 30 }}
                      defaultValue={true}
                      placeholder="Cancellation & Rescheduling"
                    >
                      <Option value={true}>Yes</Option>
                      <Option value={false}>No</Option>
                    </Select>
                  </Form.Item>
                </div> */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: isViewMode ? 0 : 15,
                    alignItems: 'center',
                  }}
                  className={isViewMode ? 'view-detail-row' : 'minbookingperiod'}
                >
                  <label>Min. booking period (days in advance):</label>
                  {isViewMode ? (
                    <span className="view-field-value" style={{ width: 71, display: 'inline-flex', alignItems: 'center' }}>{form.getFieldValue('min_booking_period_days') || clinicDataSetInUpdate?.min_booking_period_days || '-'}</span>
                  ) : (
                    <Form.Item
                      name="min_booking_period_days"
                      rules={[
                        { required: !isViewMode, message: "Min. booking period (days in advance) is required." },
                        { pattern: /^\d+(\.\d{1,2})?$/, message: "Enter a valid number (e.g., 10 or 10.99)" },
                      ]}
                    >
                      <Input style={{ width: 71, height: 30 }} placeholder="Days" />
                    </Form.Item>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: isViewMode ? 0 : 15,
                    alignItems: 'center',
                  }}
                  className={isViewMode ? 'view-detail-row' : 'minbookingperiod'}
                >
                  <label>Override spacers:</label>
                  {isViewMode ? (
                    <span className="view-field-value" style={{ width: 71, display: 'inline-flex', alignItems: 'center' }}>{form.getFieldValue('override_spacers') || clinicDataSetInUpdate?.override_spacers || '-'}</span>
                  ) : (
                    <Form.Item
                      name="override_spacers"
                      rules={[{ required: !isViewMode, message: "Override spacers is required." }]}
                    >
                      <Select style={{ width: 71, height: 30 }} placeholder="Override spacers">
                        <Option value="Yes">Yes</Option>
                        <Option value="No">No</Option>
                      </Select>
                    </Form.Item>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: isViewMode ? 0 : 15,
                    alignItems: 'center',
                  }}
                  className={isViewMode ? 'view-detail-row' : 'minbookingperiod'}
                >
                  <label>Max no. of 15-min wait slots between clinicians: </label>
                  {isViewMode ? (
                    <span className="view-field-value" style={{ width: 71, display: 'inline-flex', alignItems: 'center' }}>{form.getFieldValue('max_wait_slots_between_clinicians') || clinicDataSetInUpdate?.max_wait_slots_between_clinicians || '-'}</span>
                  ) : (
                    <Form.Item
                      name="max_wait_slots_between_clinicians"
                      rules={[{ required: !isViewMode, message: "Max no. of 15-min wait slots between clinicians is required." }]}
                    >
                      <Select style={{ width: 71, height: 30 }} placeholder="Max no. of 15-min wait slots between clinicians">
                        <Option value="0">0</Option>
                        <Option value="1">1</Option>
                        <Option value="2">2</Option>
                      </Select>
                    </Form.Item>
                  )}
                </div>

                {/* ── Teal gradient divider before clinicians ── */}
                <div style={{
                  height: 1,
                  background: 'linear-gradient(90deg, #c5e8e8 0%, #e0f5f5 60%, transparent 100%)',
                  margin: '8px 0',
                  borderRadius: 2,
                }} />

                <Form.List
                  name="clinicians"
                  initialValue={[{ type: null, duration: null }]}
                >
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }, index) => (
                        <div key={key}>
                          {isViewMode ? (
                            /* ── View mode: clinician inside a clean card box ── */
                            <div style={{
                              border: '1px solid #c5e8e8',
                              borderRadius: 10,
                              overflow: 'hidden',
                              marginBottom: 8,
                            }}>
                              {/* Card header */}
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '7px 14px',
                                background: 'linear-gradient(90deg, #e6f5f5 0%, #f0fafa 100%)',
                                borderBottom: '1px solid #c5e8e8',
                              }}>
                                <span style={{
                                  fontWeight: 700,
                                  fontSize: 13,
                                  color: '#006668',
                                  letterSpacing: 0.3,
                                }}>
                                  Clinician {index + 1}
                                </span>
                              </div>
                              {/* Card body — Type & Duration */}
                              <div className="view-detail-row" style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                gap: 16,
                                borderLeft: 'none',
                                borderRadius: 0,
                                margin: 0,
                              }}>
                                <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                                  <label style={{ marginBottom: 0 }}>Type:</label>
                                  <span className="view-field-value">
                                    {metaData && metaData.length && metaData.find(d => d.meta_id == form.getFieldValue(['clinicians', name, 'type']))?.meta_value || '-'}
                                  </span>
                                </div>
                                <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                                  <label style={{ marginBottom: 0 }}>Duration:</label>
                                  <span className="view-field-value">
                                    {form.getFieldValue(['clinicians', name, 'duration'])
                                      ? `${form.getFieldValue(['clinicians', name, 'duration'])} mins`
                                      : '-'}
                                  </span>
                                </div>
                              </div>
                            </div>
                          ) : (
                            /* ── Edit mode: original header + selects ── */
                            <>
                              <span
                                className="inputbox-custom-placeholder minbookingperiod"
                                style={{ display: "block", textAlign: "start" }}
                              >
                                Clinician {index + 1}-
                                {key > 0 && !isViewMode && (
                                  <Button
                                    type="text"
                                    icon={<DeleteOutlined />}
                                    onClick={() => remove(name)}
                                  />
                                )}
                              </span>
                              <div
                                style={{ display: "flex", flexWrap: "wrap" }}
                                className="leftInputFields"
                              >
                                <div
                                  style={{
                                    flex: "0 0 50%",
                                    display: "inline-flex",
                                    paddingRight: 10,
                                  }}
                                >
                                  <Form.Item
                                    {...restField}
                                    label="Type:"
                                    name={[name, "type"]}
                                    style={{ flex: 1 }}
                                    rules={[
                                      {
                                        required: !isViewMode,
                                        message:
                                          "Clinician type selection is required.",
                                      },
                                    ]}
                                  >
                                    <Select
                                      style={{ width: 150, height: 30 }}
                                      placeholder=" Type"
                                    >
                                      {metaData &&
                                        metaData.length &&
                                        metaData.map((data) => {
                                          return (
                                            <Option value={data.meta_id}>
                                              {data.meta_value}
                                            </Option>
                                          );
                                        })}
                                    </Select>
                                  </Form.Item>
                                </div>
                                <div
                                  style={{
                                    flex: "0 0 50%",
                                    display: "inline-flex",
                                    paddingLeft: 10,
                                  }}
                                >
                                  <Form.Item
                                    {...restField}
                                    label=" Duration:"
                                    name={[name, "duration"]}
                                    style={{ flex: 1 }}
                                    rules={[
                                      {
                                        required: !isViewMode,
                                        message: "Duration selection is required.",
                                      },
                                    ]}
                                  >
                                    <Select
                                      style={{ width: 140, height: 30 }}
                                      placeholder=" Duration"
                                    >
                                      <Option value="15">15</Option>
                                      <Option value="30">30</Option>
                                      <Option value="45">45</Option>
                                      <Option value="60">60</Option>
                                    </Select>
                                  </Form.Item>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      ))}
                      {!isViewMode && (
                        <Button
                          type="default"
                          className="add-generic-btn"
                          onClick={() => add()}
                          block
                        >
                          Add a clinician
                        </Button>
                      )}
                    </>
                  )}
                </Form.List>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: isViewMode ? 0 : 15,
                    alignItems: 'center',
                  }}
                  className={isViewMode ? 'view-detail-row' : ''}
                >
                  <label>Semble product ID:</label>
                  <Form.Item name="semble_product_id">
                    {isViewMode ? (
                      <span className="view-field-value" style={{ width: 174, display: 'inline-flex', alignItems: 'center' }}>{form.getFieldValue('semble_product_id') || '-'}</span>
                    ) : (
                      <Input style={{ width: 174, height: 30 }} />
                    )}
                  </Form.Item>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: isViewMode ? 0 : 15,
                    alignItems: 'center',
                  }}
                  className={isViewMode ? 'view-detail-row' : ''}
                >
                  <label>Gender selection:</label>
                  {isViewMode ? (
                    <span className="view-field-value" style={{ width: 174, display: 'inline-flex', alignItems: 'center' }}>
                      {form.getFieldValue('allow_gender_selection') ? 'Allow selection' : 'Hide selection'}
                    </span>
                  ) : (
                    <Form.Item name="allow_gender_selection">
                      <Select style={{ width: 174, height: 30 }} defaultValue={false} value={genderSelecttion}>
                        <Option value={false}>Hide selection</Option>
                        <Option value={true}>Allow selection</Option>
                      </Select>
                    </Form.Item>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: 'center',
                    marginTop: isViewMode ? 0 : 15,
                  }}
                  className={isViewMode ? 'view-detail-row' : ''}
                >
                  <label>Language selection:</label>
                  {isViewMode ? (
                    <span className="view-field-value" style={{ width: 174, display: 'inline-flex', alignItems: 'center' }}>
                      {form.getFieldValue('allow_language_selection') ? 'Allow selection' : 'Hide selection'}
                    </span>
                  ) : (
                    <Form.Item name="allow_language_selection">
                      <Select style={{ width: 174, height: 30 }} value={languageSelection} defaultValue={false}>
                        <Option value={false}>Hide selection</Option>
                        <Option value={true}>Allow selection</Option>
                      </Select>
                    </Form.Item>
                  )}
                </div>

                {/* ── Product Availability Configuration ───────────────────── */}
                <Divider style={{ margin: "18px 0 12px" }} />

                {/* Section header */}
                <div style={{ marginBottom: 12, textAlign: "left", background: "#f4fbfb", border: "1px solid #d0ecec", borderRadius: 10, padding: "14px 16px" }}>
                  <span style={{ fontWeight: 700, fontSize: 14, color: "#008385", display: "flex", alignItems: "center", gap: 6 }}>
                    <CalendarOutlined /> Product Availability
                  </span>
                  <span style={{ fontSize: 12, color: "#888", display: "block", marginTop: 2, textAlign: "left" }}>
                    Restrict when and where this product can be booked.
                  </span>
                </div>

                {/* ── Clinics ──────────────────────────────────────────────── */}
                <div style={{ marginBottom: 24, textAlign: "left", paddingLeft: 2, paddingRight: 2 }}>
                  <label style={{ display: "block", fontWeight: 600, marginBottom: 6, fontSize: 13, textAlign: "left" }}>
                    <BankOutlined style={{ marginRight: 5, color: "#008385" }} />
                    Available at clinics:
                  </label>

                  {/* All / Specific toggle pills — edit mode */}
                  {!isViewMode && (
                    <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
                      {[{ key: "all", label: "All Clinics" }, { key: "specific", label: "Specific Clinics" }].map((opt) => (
                        <button
                          key={opt.key}
                          type="button"
                          onClick={() => {
                            if (opt.key !== clinicMode) {
                              setClinicMode(opt.key);
                              // Do NOT reset data — preserve existing entries so switching
                              // back restores everything the user typed.
                            }
                          }}
                          style={{
                            padding: "4px 14px",
                            borderRadius: 20,
                            border: `1.5px solid ${clinicMode === opt.key ? "#008385" : "#d9d9d9"}`,
                            background: clinicMode === opt.key ? "#008385" : "#fff",
                            color: clinicMode === opt.key ? "#fff" : "#555",
                            cursor: "pointer",
                            fontWeight: clinicMode === opt.key ? 600 : 400,
                            fontSize: 12,
                            transition: "all .15s",
                          }}
                        >
                          {opt.label}
                        </button>
                      ))}
                    </div>
                  )}

                  {/* View mode — All Clinics badge */}
                  {isViewMode && clinicMode === "all" && (
                    <Tag style={{ borderColor: "#008385", color: "#008385", background: "#f0fafa", fontWeight: 600 }}>All Clinics</Tag>
                  )}

                  {/* ── SPECIFIC CLINICS: per-clinic card list ──────────────── */}
                  {clinicMode === "specific" && (
                    <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 4 }}>
                      {clinicSchedules.map((cs) => {
                        const usedIds = clinicSchedules
                          .filter((x) => x.uid !== cs.uid)
                          .flatMap((x) => x.clinicIds || []);
                        const clinicShortName = (name) => name.replace(/\s*\([^)]*London Doctors Clinic[^)]*\)\s*/i, '').trim() || name;
                        const availableOptions = allClinicsForAvailability
                          .filter((c) => !usedIds.includes(c.id))
                          .map((c) => ({ label: clinicShortName(c.name || ''), value: c.id }));
                        const selectedClinics = allClinicsForAvailability.filter((c) => (cs.clinicIds || []).includes(c.id));
                        return (
                          <div key={cs.uid}
                            style={{
                              border: `1px solid ${cs.expanded ? '#008385' : '#c8e6e6'}`,
                              borderRadius: 10,
                              background: "#f4fafa",
                              overflow: "hidden",
                              transition: "border-color 0.2s",
                            }}
                          >
                            {/* ── Clickable header row ── */}
                            <div
                              style={{
                                position: "relative",
                                padding: "10px 12px",
                                cursor: "pointer",
                                userSelect: "none",
                                borderBottom: cs.expanded ? "1px solid #d8eeee" : "none",
                                background: cs.expanded ? "#eaf6f6" : "transparent",
                                transition: "background 0.2s",
                              }}
                              onClick={() => toggleClinicCard(cs.uid)}
                            >
                              {/* Clinic selector / tag list */}
                              {isViewMode ? (
                                <div style={{ display: "flex", flexWrap: "wrap", gap: 4, paddingRight: 52, paddingTop: 2 }}>
                                  {selectedClinics.length > 0
                                    ? selectedClinics.map((c) => (
                                        <Tag key={c.id} style={{ borderColor: "#008385", color: "#008385", background: "#e6f5f5", fontWeight: 600, margin: 0 }}>
                                          {clinicShortName(c.name || '')}
                                        </Tag>
                                      ))
                                    : <span style={{ color: "#bbb", fontSize: 12 }}>No clinic selected</span>}
                                </div>
                              ) : (
                                <div style={{ paddingRight: 56 }} onClick={(e) => e.stopPropagation()}>
                                  <Select
                                    mode="multiple"
                                    style={{ width: "100%" }}
                                    placeholder="Select clinics"
                                    value={cs.clinicIds || []}
                                    onChange={(val) => updateClinicCard(cs.uid, (c) => ({ ...c, clinicIds: val }))}
                                    options={availableOptions}
                                    size="small"
                                    status={!isViewMode && clinicMode === 'specific' && (cs.clinicIds || []).length === 0 ? 'error' : ''}
                                  />
                                  {!isViewMode && clinicMode === 'specific' && (cs.clinicIds || []).length === 0 && (
                                    <span style={{ color: '#ff4d4f', fontSize: 11, marginTop: 2, display: 'block' }}>Please select at least one clinic.</span>
                                  )}
                                  {!isViewMode && allClinicsForAvailability.length === 0 && (
                                    <span style={{ color: '#fa8c16', fontSize: 11, marginTop: 2, display: 'block' }}>⚠ Could not load clinic list. Please refresh and try again.</span>
                                  )}
                                </div>
                              )}
                              {/* Action buttons — absolutely pinned top-right */}
                              <div
                                style={{
                                  position: "absolute",
                                  top: 8,
                                  right: 10,
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 2,
                                  background: cs.expanded ? "#eaf6f6" : "#f4fafa",
                                  borderRadius: 6,
                                  padding: "2px 0",
                                }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <DownOutlined
                                  onClick={() => toggleClinicCard(cs.uid)}
                                  style={{
                                    fontSize: 11,
                                    color: "#008385",
                                    cursor: "pointer",
                                    transform: cs.expanded ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "transform 0.2s",
                                    padding: "4px 6px",
                                  }}
                                />
                                {!isViewMode && (
                                  <Button
                                    type="text"
                                    size="small"
                                    icon={<DeleteOutlined />}
                                    style={{ color: "#ff4d4f", padding: "0 4px", height: 24 }}
                                    onClick={(e) => { e.stopPropagation(); removeClinicSchedule(cs.uid); }}
                                  />
                                )}
                              </div>
                            </div>

                            {/* ── Day schedule body (only when expanded) ── */}
                            {cs.expanded && (
                              <div style={{ padding: "12px 18px 16px" }}>
                              <label style={{ display: "block", fontWeight: 600, marginBottom: 6, fontSize: 12, color: "#555" }}>
                                <ClockCircleOutlined style={{ marginRight: 4, color: "#008385" }} />
                                Day schedule:
                              </label>

                              {isViewMode ? (
                                <Tag style={{ borderColor: "#008385", color: "#008385", background: "#f0fafa", fontWeight: 600, marginBottom: 8, display: "inline-block" }}>
                                  {cs.dayScheduleMode === "all" ? "All Days" : cs.dayScheduleMode === "custom" ? "Custom Days" : "Custom Dates"}
                                </Tag>
                              ) : (
                                <div style={{ display: "flex", gap: 6, marginBottom: 10 }}>
                                  {[{ key: "all", label: "All Days" }, { key: "custom", label: "Custom Days" }, { key: "dates", label: "Custom Dates" }].map((opt) => (
                                    <button key={opt.key} type="button"
                                      onClick={() => {
                                        if (opt.key !== cs.dayScheduleMode) {
                                          updateClinicCard(cs.uid, (c) => ({
                                            ...c,
                                            dayScheduleMode: opt.key,
                                            // Do NOT reset data — preserve existing entries so
                                            // switching back restores what the user typed.
                                          }));
                                        }
                                      }}
                                      style={{ padding: "3px 10px", borderRadius: 20, border: `1.5px solid ${cs.dayScheduleMode === opt.key ? "#008385" : "#d9d9d9"}`, background: cs.dayScheduleMode === opt.key ? "#008385" : "#fff", color: cs.dayScheduleMode === opt.key ? "#fff" : "#555", cursor: "pointer", fontSize: 11, transition: "all .15s" }}
                                    >{opt.label}</button>
                                  ))}
                                </div>
                              )}

                              {/* All Days */}
                              {cs.dayScheduleMode === "all" && (
                                <div style={{ background: "#fff", border: "1px solid #e0f0f0", borderRadius: 8, padding: "8px 10px" }}>
                                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: cs.allDaysTimes.some((s) => s.isWholeDay) ? 0 : 6 }}>
                                    <span style={{ fontWeight: 600, fontSize: 12, color: "#333" }}>All Days</span>
                                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                      {isViewMode ? (
                                        cs.allDaysTimes.some((s) => s.isWholeDay)
                                          ? <Tag style={{ borderColor: "#008385", color: "#008385", background: "#e6f5f5", fontWeight: 600, margin: 0 }}>Whole Day</Tag>
                                          : null
                                      ) : (
                                        <Button size="small"
                                          type={cs.allDaysTimes.some((s) => s.isWholeDay) ? "primary" : "default"}
                                          onClick={() => clinicToggleAllDaysWhole(cs.uid)}
                                          style={cs.allDaysTimes.some((s) => s.isWholeDay)
                                            ? { fontSize: 11, backgroundColor: "#008385", borderColor: "#008385", color: "#fff", padding: "0 10px" }
                                            : { fontSize: 11, borderColor: "#008385", color: "#008385", padding: "0 10px" }}
                                        >{cs.allDaysTimes.some((s) => s.isWholeDay) ? "Whole Day ✓" : "Whole Day"}</Button>
                                      )}
                                    </div>
                                  </div>
                                  {cs.allDaysTimes.some((s) => s.isWholeDay) ? (
                                    <div style={{ marginTop: 6 }}>
                                    <span style={{ fontSize: 12, color: "#008385", fontStyle: "italic" }}>Available all day</span>
                                    </div>
                                  ) : (
                                    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                      {cs.allDaysTimes.map((slot) => (
                                        <div key={slot.id} style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                          {isViewMode ? (
                                            <><Tag style={{ border: "1px solid #d9d9d9", background: "#fafafa" }}>{slot.startTime ? slot.startTime.format("HH:mm") : "--:--"}</Tag><span style={{ color: "#aaa", fontSize: 12 }}>–</span><Tag style={{ border: "1px solid #d9d9d9", background: "#fafafa" }}>{slot.endTime ? slot.endTime.format("HH:mm") : "--:--"}</Tag></>
                                          ) : (
                                            <><TimePicker style={{ width: 95 }} value={slot.startTime} placeholder="Start" format="HH:mm" onChange={(v) => clinicUpdateAllDaysSlot(cs.uid, slot.id, 'startTime', v)} size="small" /><span style={{ color: "#aaa", fontSize: 12 }}>–</span><TimePicker style={{ width: 95 }} value={slot.endTime} placeholder="End" format="HH:mm" onChange={(v) => clinicUpdateAllDaysSlot(cs.uid, slot.id, 'endTime', v)} size="small" />{cs.allDaysTimes.length > 1 && <Button type="text" size="small" icon={<DeleteOutlined />} style={{ color: "#ff4d4f" }} onClick={() => clinicRemoveAllDaysSlot(cs.uid, slot.id)} />}</>
                                          )}
                                        </div>
                                      ))}
                                      {!isViewMode && hasTimeOverlap(cs.allDaysTimes) && <span style={{ color: "#ff4d4f", fontSize: 11 }}>⚠ Time slots overlap or a start time is not before its end time.</span>}
                                      {!isViewMode && <Button type="dashed" size="small" icon={<PlusOutlined />} onClick={() => clinicAddAllDaysSlot(cs.uid)} style={{ marginTop: 4, borderColor: "#008385", color: "#008385", width: "100%" }}>Add Times</Button>}
                                    </div>
                                  )}
                                </div>
                              )}

                              {/* Custom Days */}
                              {cs.dayScheduleMode === "custom" && (
                                <div>
                                  {!isViewMode && (
                                    <Select mode="multiple" style={{ width: "100%", marginBottom: 10 }} placeholder="Select days"
                                      value={cs.customDaysSelected}
                                      onChange={(v) => clinicSetCustomDays(cs.uid, v)}
                                      options={DAYS_OF_WEEK.map((d) => ({ label: d.label, value: d.value }))}
                                      size="small"
                                    />
                                  )}
                                  <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                                    {[...cs.customDaysSelected]
                                      .sort((a, b) => DAYS_OF_WEEK.findIndex(d => d.value === a) - DAYS_OF_WEEK.findIndex(d => d.value === b))
                                      .map((dayVal) => {
                                      const dayLabel = DAYS_OF_WEEK.find((d) => d.value === dayVal)?.label || dayVal;
                                      const slots = cs.customDaysTimes[dayVal] || [{ id: 1, startTime: null, endTime: null, isWholeDay: true }];
                                      return (
                                        <div key={dayVal} style={{ background: "#fff", border: "1px solid #e0f0f0", borderRadius: 8, padding: "6px 10px" }}>
                                          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4 }}>
                                            <span style={{ fontWeight: 600, fontSize: 12, color: "#333" }}>{dayLabel}</span>
                                            {!isViewMode && (
                                              <Button size="small"
                                                type={slots.some((s) => s.isWholeDay) ? "primary" : "default"}
                                                onClick={() => clinicToggleCustomDayWhole(cs.uid, dayVal)}
                                                style={slots.some((s) => s.isWholeDay)
                                                  ? { fontSize: 11, backgroundColor: "#008385", borderColor: "#008385", color: "#fff", padding: "0 10px" }
                                                  : { fontSize: 11, borderColor: "#008385", color: "#008385", padding: "0 10px" }}
                                              >Whole Day</Button>
                                            )}
                                            {isViewMode && slots.some((s) => s.isWholeDay) && <Tag style={{ borderColor: "#008385", color: "#008385", background: "#e6f5f5", fontWeight: 600 }}>Whole Day</Tag>}
                                          </div>
                                          {!slots.some((s) => s.isWholeDay) && (
                                            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                              {slots.map((slot) => (
                                                <div key={slot.id} style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                                  {isViewMode ? (
                                                    <><Tag style={{ border: "1px solid #d9d9d9", background: "#fafafa" }}>{slot.startTime ? slot.startTime.format("HH:mm") : "--:--"}</Tag><span style={{ color: "#aaa", fontSize: 12 }}>–</span><Tag style={{ border: "1px solid #d9d9d9", background: "#fafafa" }}>{slot.endTime ? slot.endTime.format("HH:mm") : "--:--"}</Tag></>
                                                  ) : (
                                                    <><TimePicker style={{ width: 95 }} value={slot.startTime} placeholder="Start" format="HH:mm" onChange={(v) => clinicUpdateCustomDayTime(cs.uid, dayVal, slot.id, 'startTime', v)} size="small" /><span style={{ color: "#aaa", fontSize: 12 }}>–</span><TimePicker style={{ width: 95 }} value={slot.endTime} placeholder="End" format="HH:mm" onChange={(v) => clinicUpdateCustomDayTime(cs.uid, dayVal, slot.id, 'endTime', v)} size="small" />{slots.length > 1 && <Button type="text" size="small" icon={<DeleteOutlined />} style={{ color: "#ff4d4f" }} onClick={() => clinicRemoveCustomDaySlot(cs.uid, dayVal, slot.id)} />}</>
                                                  )}
                                                </div>
                                              ))}
                                              {!isViewMode && hasTimeOverlap(slots) && <span style={{ color: "#ff4d4f", fontSize: 11 }}>⚠ Slots overlap or start ≥ end.</span>}
                                              {!isViewMode && <Button type="dashed" size="small" icon={<PlusOutlined />} onClick={() => clinicAddCustomDaySlot(cs.uid, dayVal)} style={{ marginTop: 4, borderColor: "#008385", color: "#008385", width: "100%" }}>Add Times</Button>}
                                            </div>
                                          )}
                                        </div>
                                      );
                                    })}
                                    {cs.customDaysSelected.length === 0 && <span style={{ fontSize: 12, color: "#bbb" }}>No days selected.</span>}
                                  </div>

                                  {/* ── Additional Specific Dates (per-clinic) ── */}
                                  <div style={{ marginTop: 12, borderTop: '1.5px dashed #c5e8e8', paddingTop: 10 }}>
                                    <div style={{ fontSize: 11.5, fontWeight: 600, color: '#008385', marginBottom: 3, display: 'flex', alignItems: 'center', gap: 5 }}>
                                      <CalendarOutlined /> Additional Specific Dates
                                    </div>
                                    <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 8 }}>
                                      These specific dates will be available in addition to the recurring days above.
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                                      {(cs.customDaysExtraDates || []).map((row) => (
                                        <div key={row.id} style={{ background: '#fff', border: '1px solid #e0f0f0', borderRadius: 7, padding: '6px 8px' }}>
                                          <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', marginBottom: 4 }}>
                                            {isViewMode ? (
                                              <Tag style={{ border: '1px solid #d9d9d9', background: '#fafafa', minWidth: 90 }}>
                                                {row.date ? row.date.format('DD/MM/YYYY') : <span style={{ color: '#bbb' }}>No date</span>}
                                              </Tag>
                                            ) : (
                                              <DatePicker
                                                style={{ flex: 1, minWidth: 110 }}
                                                value={row.date}
                                                placeholder="Select date"
                                                onChange={(val) => clinicUpdateExtraDate(cs.uid, row.id, 'date', val)}
                                                format="DD/MM/YYYY"
                                                size="small"
                                                disabledDate={(current) => {
                                                  if (!current) return false;
                                                  if (current.isBefore(dayjs().startOf('day'))) return true;
                                                  const DAY_MAP = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
                                                  if ((cs.customDaysSelected || []).includes(DAY_MAP[current.day()])) return true;
                                                  if ((cs.customDaysExtraDates || []).some(r => r.id !== row.id && r.date && r.date.isSame(current, 'day'))) return true;
                                                  return false;
                                                }}
                                              />
                                            )}
                                            {!isViewMode && <Button type="text" size="small" icon={<DeleteOutlined />} style={{ color: '#ff4d4f', marginLeft: 'auto' }} onClick={() => clinicRemoveExtraDate(cs.uid, row.id)} />}
                                          </div>
                                          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                            {(row.slots || []).map((slot) => (
                                              <div key={slot.id} style={{ display: 'flex', alignItems: 'center', gap: 5, flexWrap: 'wrap', paddingLeft: 6 }}>
                                                {isViewMode ? (
                                                  slot.isWholeDay ? (
                                                    <Tag style={{ borderColor: '#008385', color: '#008385', background: '#e6f5f5', fontWeight: 600, fontSize: 11 }}>Whole Day</Tag>
                                                  ) : (
                                                    <><Tag style={{ border: '1px solid #d9d9d9', background: '#fafafa', fontSize: 11 }}>{slot.startTime ? slot.startTime.format('HH:mm') : '--:--'}</Tag><span style={{ color: '#aaa', fontSize: 11 }}>–</span><Tag style={{ border: '1px solid #d9d9d9', background: '#fafafa', fontSize: 11 }}>{slot.endTime ? slot.endTime.format('HH:mm') : '--:--'}</Tag></>
                                                  )
                                                ) : (
                                                  <>
                                                    <Button size="small" type={slot.isWholeDay ? 'primary' : 'default'} onClick={() => clinicToggleExtraDateWhole(cs.uid, row.id)} style={slot.isWholeDay ? { fontSize: 10, backgroundColor: '#008385', borderColor: '#008385', color: '#fff', padding: '0 8px' } : { fontSize: 10, borderColor: '#008385', color: '#008385', padding: '0 8px' }}>Whole Day</Button>
                                                    {!slot.isWholeDay && (<><TimePicker style={{ width: 85 }} value={slot.startTime} placeholder="Start" format="HH:mm" onChange={(val) => clinicUpdateExtraDateSlot(cs.uid, row.id, slot.id, 'startTime', val)} size="small" /><span style={{ color: '#aaa', fontSize: 11 }}>–</span><TimePicker style={{ width: 85 }} value={slot.endTime} placeholder="End" format="HH:mm" onChange={(val) => clinicUpdateExtraDateSlot(cs.uid, row.id, slot.id, 'endTime', val)} size="small" /></>)}
                                                    {(row.slots || []).length > 1 && <Button type="text" size="small" icon={<DeleteOutlined />} style={{ color: '#ff4d4f' }} onClick={() => clinicRemoveExtraDateSlot(cs.uid, row.id, slot.id)} />}
                                                  </>
                                                )}
                                              </div>
                                            ))}
                                            {!isViewMode && <Button type="dashed" size="small" icon={<PlusOutlined />} onClick={() => clinicAddExtraDateSlot(cs.uid, row.id)} style={{ marginTop: 2, borderColor: '#008385', color: '#008385', fontSize: 10 }}>Add Times</Button>}
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                    {!isViewMode && (
                                      <Button
                                        type="dashed"
                                        size="small"
                                        icon={<PlusOutlined />}
                                        onClick={() => clinicAddExtraDate(cs.uid)}
                                        style={{ marginTop: 6, borderColor: '#008385', color: '#008385', width: '100%', fontSize: 11 }}
                                      >
                                        Add Specific Date
                                      </Button>
                                    )}
                                  </div>
                                </div>
                              )}

                              {/* Custom Dates */}
                              {cs.dayScheduleMode === "dates" && (
                                <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                                  {cs.customDateRanges.map((row) => (
                                    <div key={row.id} style={{ background: '#fff', border: '1px solid #e0f0f0', borderRadius: 7, padding: '6px 8px' }}>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', marginBottom: 4 }}>
                                        {isViewMode ? (
                                          <Tag style={{ border: "1px solid #d9d9d9", background: "#fafafa" }}>{row.date ? row.date.format("DD/MM/YYYY") : "--"}</Tag>
                                        ) : (
                                          <DatePicker style={{ width: 120 }} value={row.date} format="DD/MM/YYYY" onChange={(v) => clinicUpdateCustomDateRow(cs.uid, row.id, 'date', v)} size="small" disabledDate={(current) => current && (current.isBefore(dayjs().startOf('day')) || cs.customDateRanges.some(r => r.id !== row.id && r.date && r.date.isSame(current, 'day')))} />
                                        )}
                                        {!isViewMode && cs.customDateRanges.length > 1 && <Button type="text" size="small" icon={<DeleteOutlined />} style={{ color: '#ff4d4f', marginLeft: 'auto' }} onClick={() => clinicRemoveCustomDateRow(cs.uid, row.id)} />}
                                      </div>
                                      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                        {(row.slots || []).map((slot) => (
                                          <div key={slot.id} style={{ display: 'flex', alignItems: 'center', gap: 5, flexWrap: 'wrap', paddingLeft: 6 }}>
                                            {isViewMode ? (
                                              slot.isWholeDay ? (
                                                <Tag style={{ borderColor: '#008385', color: '#008385', background: '#e6f5f5', fontWeight: 600, fontSize: 11 }}>Whole Day</Tag>
                                              ) : (
                                                <><Tag style={{ border: '1px solid #d9d9d9', background: '#fafafa', fontSize: 11 }}>{slot.startTime ? slot.startTime.format('HH:mm') : '--:--'}</Tag><span style={{ color: '#aaa', fontSize: 12 }}>–</span><Tag style={{ border: '1px solid #d9d9d9', background: '#fafafa', fontSize: 11 }}>{slot.endTime ? slot.endTime.format('HH:mm') : '--:--'}</Tag></>
                                              )
                                            ) : (
                                              <>
                                                <Button size="small" type={slot.isWholeDay ? "primary" : "default"} onClick={() => clinicToggleCustomDateWhole(cs.uid, row.id)} style={slot.isWholeDay ? { fontSize: 11, backgroundColor: "#008385", borderColor: "#008385", color: "#fff", padding: "0 10px" } : { fontSize: 11, borderColor: "#008385", color: "#008385", padding: "0 10px" }}>Whole Day</Button>
                                                {!slot.isWholeDay && (<><TimePicker style={{ width: 90 }} value={slot.startTime} placeholder="Start" format="HH:mm" onChange={(v) => clinicUpdateCustomDateSlot(cs.uid, row.id, slot.id, 'startTime', v)} size="small" /><span style={{ color: "#aaa", fontSize: 12 }}>–</span><TimePicker style={{ width: 90 }} value={slot.endTime} placeholder="End" format="HH:mm" onChange={(v) => clinicUpdateCustomDateSlot(cs.uid, row.id, slot.id, 'endTime', v)} size="small" /></>)}
                                                {(row.slots || []).length > 1 && <Button type="text" size="small" icon={<DeleteOutlined />} style={{ color: '#ff4d4f' }} onClick={() => clinicRemoveCustomDateSlot(cs.uid, row.id, slot.id)} />}
                                              </>
                                            )}
                                          </div>
                                        ))}
                                        {!isViewMode && <Button type="dashed" size="small" icon={<PlusOutlined />} onClick={() => clinicAddCustomDateSlot(cs.uid, row.id)} style={{ marginTop: 4, borderColor: "#008385", color: "#008385", width: "100%", fontSize: 11 }}>Add Times</Button>}
                                      </div>
                                    </div>
                                  ))}
                                  {!isViewMode && <Button type="dashed" size="small" icon={<PlusOutlined />} onClick={() => clinicAddCustomDateRow(cs.uid)} style={{ marginTop: 6, borderColor: "#008385", color: "#008385", width: "100%" }}>Add date</Button>}
                                </div>
                              )}
                            </div>
                            )}
                          </div>
                        );
                      })}

                      {/* + Add Availability Configuration button */}
                      {!isViewMode && (
                        <Button
                          type="dashed"
                          icon={<PlusOutlined />}
                          onClick={addClinicSchedule}
                          style={{ borderColor: "#008385", color: "#008385", width: "100%" }}
                        >
                          Add Availability Configuration
                        </Button>
                      )}
                    </div>
                  )}
                </div>

                {/* ── Day schedule (global — only shown when All Clinics) ───── */}
                {clinicMode === "all" && (
                <div style={{ marginBottom: 10, textAlign: "left" }}>
                  <label style={{ display: "block", fontWeight: 600, marginBottom: 8, fontSize: 13, textAlign: "left" }}>
                    <ClockCircleOutlined style={{ marginRight: 5, color: "#008385" }} />
                    Day schedule:
                  </label>

                  {isViewMode ? (
                    <Tag style={{ borderColor: "#008385", color: "#008385", background: "#f0fafa", fontWeight: 600 }}>
                      {dayScheduleMode === "all" ? "All Days" : dayScheduleMode === "custom" ? "Custom Days" : "Custom Dates"}
                    </Tag>
                  ) : (
                    <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
                      {[{ key: "all", label: "All Days" }, { key: "custom", label: "Custom Days" }, { key: "dates", label: "Custom Dates" }].map((opt) => (
                        <button
                          key={opt.key}
                          type="button"
                          onClick={() => {
                              if (opt.key !== dayScheduleMode) {
                                setDayScheduleMode(opt.key);
                                // Do NOT reset data — preserve existing entries so switching
                                // back restores everything the user typed.
                              }
                            }}
                          style={{
                            padding: "4px 14px",
                            borderRadius: 20,
                            border: `1.5px solid ${dayScheduleMode === opt.key ? "#008385" : "#d9d9d9"}`,
                            background: dayScheduleMode === opt.key ? "#008385" : "#fff",
                            color: dayScheduleMode === opt.key ? "#fff" : "#555",
                            cursor: "pointer",
                            fontWeight: dayScheduleMode === opt.key ? 600 : 400,
                            fontSize: 12,
                            transition: "all .15s",
                          }}
                        >
                          {opt.label}
                        </button>
                      ))}
                    </div>
                  )}

                  {/* ════ ALL DAYS ════ */}
                  {dayScheduleMode === "all" && (
                    <div style={{ background: "#f9fdfd", border: "1px solid #e0f0f0", borderRadius: 8, padding: "10px 12px" }}>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: allDaysTimes.some((s) => s.isWholeDay) ? 0 : 8 }}>
                        <span style={{ fontWeight: 600, fontSize: 13, color: "#333" }}>All Days</span>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          {isViewMode ? (
                            allDaysTimes.some((s) => s.isWholeDay)
                              ? <Tag style={{ borderColor: "#008385", color: "#008385", background: "#e6f5f5", fontWeight: 600, margin: 0 }}>Whole Day</Tag>
                              : null
                          ) : (
                            <Button
                              size="small"
                              type={allDaysTimes.some((s) => s.isWholeDay) ? "primary" : "default"}
                              onClick={toggleAllDaysWhole}
                              style={allDaysTimes.some((s) => s.isWholeDay)
                                ? { fontSize: 11, backgroundColor: "#008385", borderColor: "#008385", color: "#fff", padding: "0 10px" }
                                : { fontSize: 11, borderColor: "#008385", color: "#008385", padding: "0 10px" }}
                            >
                              {allDaysTimes.some((s) => s.isWholeDay) ? "Whole Day ✓" : "Whole Day"}
                            </Button>
                          )}
                        </div>
                      </div>
                      {allDaysTimes.some((s) => s.isWholeDay) ? (
                        <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 6 }}>
                          <span style={{ fontSize: 12, color: "#008385", fontStyle: "italic" }}>Available all day</span>
                        </div>
                      ) : (
                        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                          {allDaysTimes.map((slot) => (
                            <div key={slot.id} style={{ display: "flex", alignItems: "center", gap: 6 }}>
                              {isViewMode ? (
                                <>
                                  <Tag style={{ border: "1px solid #d9d9d9", background: "#fafafa" }}>
                                    {slot.startTime ? slot.startTime.format("HH:mm") : <span style={{ color: "#bbb" }}>--:--</span>}
                                  </Tag>
                                  <span style={{ color: "#aaa", fontSize: 12 }}>–</span>
                                  <Tag style={{ border: "1px solid #d9d9d9", background: "#fafafa" }}>
                                    {slot.endTime ? slot.endTime.format("HH:mm") : <span style={{ color: "#bbb" }}>--:--</span>}
                                  </Tag>
                                </>
                              ) : (
                                <>
                                  <TimePicker style={{ width: 108 }} value={slot.startTime} placeholder="Start time" format="HH:mm" onChange={(val) => updateAllDaysSlot(slot.id, 'startTime', val)} size="small" />
                                  <span style={{ color: "#aaa", fontSize: 12 }}>–</span>
                                  <TimePicker style={{ width: 108 }} value={slot.endTime} placeholder="End time" format="HH:mm" onChange={(val) => updateAllDaysSlot(slot.id, 'endTime', val)} size="small" />
                                  {allDaysTimes.length > 1 && (
                                    <Button type="text" size="small" icon={<DeleteOutlined />} style={{ color: "#ff4d4f" }} onClick={() => removeAllDaysSlot(slot.id)} />
                                  )}
                                </>
                              )}
                            </div>
                          ))}
                          {!isViewMode && hasTimeOverlap(allDaysTimes) && (
                            <span style={{ color: "#ff4d4f", fontSize: 11 }}>⚠ Time slots overlap or a start time is not before its end time.</span>
                          )}
                          {!isViewMode && (
                            <Button type="dashed" size="small" icon={<PlusOutlined />} onClick={addAllDaysSlot} style={{ marginTop: 4, borderColor: "#008385", color: "#008385", width: "100%" }}>
                              Add Times
                            </Button>
                          )}
                        </div>
                      )}
                    </div>
                  )}

                  {/* ════ CUSTOM DAYS ════ */}
                  {dayScheduleMode === "custom" && (
                    <div>
                      {!isViewMode && (
                        <Select
                          mode="multiple"
                          allowClear
                          style={{ width: "100%", marginBottom: 10 }}
                          placeholder="Select days"
                          value={customDaysSelected}
                          onChange={setCustomDaysSelected}
                          options={DAYS_OF_WEEK.map((d) => ({ label: d.label, value: d.value }))}
                        />
                      )}
                      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                        {[...customDaysSelected]
                          .sort((a, b) => DAYS_OF_WEEK.findIndex(d => d.value === a) - DAYS_OF_WEEK.findIndex(d => d.value === b))
                          .map((dayVal) => {
                          const dayLabel = DAYS_OF_WEEK.find((d) => d.value === dayVal)?.label || dayVal;
                          const slots = customDaysTimes[dayVal] || [{ id: 1, startTime: null, endTime: null, isWholeDay: true }];
                          return (
                            <div key={dayVal} style={{ background: "#f9fdfd", border: "1px solid #e0f0f0", borderRadius: 8, padding: "8px 12px" }}>
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
                                <span style={{ fontWeight: 600, fontSize: 13, color: "#333" }}>{dayLabel}</span>
                                {!isViewMode && (
                                  <Button
                                    size="small"
                                    type={slots.some((s) => s.isWholeDay) ? "primary" : "default"}
                                    onClick={() => toggleCustomDayWhole(dayVal)}
                                    style={slots.some((s) => s.isWholeDay)
                                      ? { fontSize: 11, backgroundColor: "#008385", borderColor: "#008385", color: "#fff", padding: "0 10px" }
                                      : { fontSize: 11, borderColor: "#008385", color: "#008385", padding: "0 10px" }}
                                  >
                                    Whole Day
                                  </Button>
                                )}
                                {isViewMode && slots.some((s) => s.isWholeDay) && (
                                  <Tag style={{ borderColor: "#008385", color: "#008385", background: "#e6f5f5", fontWeight: 600 }}>Whole Day</Tag>
                                )}
                              </div>
                              {!slots.some((s) => s.isWholeDay) && (
                                <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                                  {slots.map((slot) => (
                                    <div key={slot.id} style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                      {isViewMode ? (
                                        <>
                                          <Tag style={{ border: "1px solid #d9d9d9", background: "#fafafa" }}>
                                            {slot.startTime ? slot.startTime.format("HH:mm") : <span style={{ color: "#bbb" }}>--:--</span>}
                                          </Tag>
                                          <span style={{ color: "#aaa", fontSize: 12 }}>–</span>
                                          <Tag style={{ border: "1px solid #d9d9d9", background: "#fafafa" }}>
                                            {slot.endTime ? slot.endTime.format("HH:mm") : <span style={{ color: "#bbb" }}>--:--</span>}
                                          </Tag>
                                        </>
                                      ) : (
                                        <>
                                          <TimePicker style={{ width: 108 }} value={slot.startTime} placeholder="Start time" format="HH:mm" onChange={(val) => updateCustomDayTime(dayVal, slot.id, 'startTime', val)} size="small" />
                                          <span style={{ color: "#aaa", fontSize: 12 }}>–</span>
                                          <TimePicker style={{ width: 108 }} value={slot.endTime} placeholder="End time" format="HH:mm" onChange={(val) => updateCustomDayTime(dayVal, slot.id, 'endTime', val)} size="small" />
                                          {slots.length > 1 && (
                                            <Button type="text" size="small" icon={<DeleteOutlined />} style={{ color: "#ff4d4f" }} onClick={() => removeCustomDaySlot(dayVal, slot.id)} />
                                          )}
                                        </>
                                      )}
                                    </div>
                                  ))}
                                  {!isViewMode && hasTimeOverlap(slots) && (
                                    <span style={{ color: "#ff4d4f", fontSize: 11 }}>⚠ Time slots overlap or a start time is not before its end time.</span>
                                  )}
                                  {!isViewMode && (
                                    <Button type="dashed" size="small" icon={<PlusOutlined />} onClick={() => addCustomDaySlot(dayVal)} style={{ marginTop: 4, borderColor: "#008385", color: "#008385", width: "100%" }}>
                                      Add Times
                                    </Button>
                                  )}
                                </div>
                              )}
                            </div>
                          );
                        })}
                        {customDaysSelected.length === 0 && (
                          <span style={{ fontSize: 12, color: "#bbb" }}>No days selected.</span>
                        )}
                      </div>

                      {/* ── Additional Specific Dates (global) ── */}
                      <div style={{ marginTop: 14, borderTop: '1.5px dashed #c5e8e8', paddingTop: 12 }}>
                        <div style={{ fontSize: 12, fontWeight: 600, color: '#008385', marginBottom: 4, display: 'flex', alignItems: 'center', gap: 6 }}>
                          <CalendarOutlined /> Additional Specific Dates
                        </div>
                        <div style={{ fontSize: 11.5, color: '#6b7280', marginBottom: 10 }}>
                          These specific dates will be available in addition to the recurring days above.
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                          {customDaysExtraDates.map((row) => (
                            <div key={row.id} style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', background: '#f9fdfd', border: '1px solid #e0f0f0', borderRadius: 8, padding: '7px 10px' }}>
                              {isViewMode ? (
                                <>
                                  <Tag style={{ border: '1px solid #d9d9d9', background: '#fafafa', minWidth: 96 }}>
                                    {row.date ? row.date.format('DD/MM/YYYY') : <span style={{ color: '#bbb' }}>No date</span>}
                                  </Tag>
                                  <span style={{ color: '#aaa', fontSize: 12 }}>→</span>
                                  {row.isWholeDay ? (
                                    <Tag style={{ borderColor: '#008385', color: '#008385', background: '#e6f5f5', fontWeight: 600 }}>Whole Day</Tag>
                                  ) : (
                                    <>
                                      <Tag style={{ border: '1px solid #d9d9d9', background: '#fafafa' }}>{row.startTime ? row.startTime.format('HH:mm') : '--:--'}</Tag>
                                      <span style={{ color: '#aaa', fontSize: 12 }}>–</span>
                                      <Tag style={{ border: '1px solid #d9d9d9', background: '#fafafa' }}>{row.endTime ? row.endTime.format('HH:mm') : '--:--'}</Tag>
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  <DatePicker
                                    style={{ flex: 1, minWidth: 120 }}
                                    value={row.date}
                                    placeholder="Select date"
                                    onChange={(val) => updateCustomDaysExtraDate(row.id, 'date', val)}
                                    format="DD/MM/YYYY"
                                    size="small"
                                    disabledDate={(current) => {
                                      if (!current) return false;
                                      if (current.isBefore(dayjs().startOf('day'))) return true;
                                      const DAY_MAP = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
                                      if (customDaysSelected.includes(DAY_MAP[current.day()])) return true;
                                      if (customDaysExtraDates.some(r => r.id !== row.id && r.date && r.date.isSame(current, 'day'))) return true;
                                      return false;
                                    }}
                                  />
                                  {!row.isWholeDay && (
                                    <>
                                      <TimePicker style={{ width: 100 }} value={row.startTime} placeholder="Start" format="HH:mm" onChange={(val) => updateCustomDaysExtraDate(row.id, 'startTime', val)} size="small" />
                                      <span style={{ color: '#aaa', fontSize: 12 }}>–</span>
                                      <TimePicker style={{ width: 100 }} value={row.endTime} placeholder="End" format="HH:mm" onChange={(val) => updateCustomDaysExtraDate(row.id, 'endTime', val)} size="small" />
                                    </>
                                  )}
                                  <Button
                                    size="small"
                                    type={row.isWholeDay ? 'primary' : 'default'}
                                    onClick={() => updateCustomDaysExtraDate(row.id, 'isWholeDay', !row.isWholeDay)}
                                    style={row.isWholeDay
                                      ? { fontSize: 11, backgroundColor: '#008385', borderColor: '#008385', color: '#fff', padding: '0 10px' }
                                      : { fontSize: 11, borderColor: '#008385', color: '#008385', padding: '0 10px' }}
                                  >
                                    Whole Day
                                  </Button>
                                  <Button type="text" size="small" icon={<DeleteOutlined />} style={{ color: '#ff4d4f' }} onClick={() => removeCustomDaysExtraDate(row.id)} />
                                </>
                              )}
                            </div>
                          ))}
                        </div>
                        {!isViewMode && (
                          <Button
                            type="dashed"
                            size="small"
                            icon={<PlusOutlined />}
                            onClick={addCustomDaysExtraDate}
                            style={{ marginTop: 8, borderColor: '#008385', color: '#008385', width: '100%' }}
                          >
                            Add Specific Date
                          </Button>
                        )}
                      </div>
                    </div>
                  )}

                  {/* ════ CUSTOM DATES ════ */}
                  {dayScheduleMode === "dates" && (
                    <div>
                      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                        {customDateRanges.map((row) => (
                          <div key={row.id} style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", background: "#f9fdfd", border: "1px solid #e0f0f0", borderRadius: 8, padding: "8px 10px" }}>
                            {isViewMode ? (
                              <>
                                <Tag style={{ border: "1px solid #d9d9d9", background: "#fafafa", minWidth: 96 }}>
                                  {row.date ? row.date.format("DD/MM/YYYY") : <span style={{ color: "#bbb" }}>No date</span>}
                                </Tag>
                                <span style={{ color: "#aaa", fontSize: 12 }}>→</span>
                                {row.isWholeDay ? (
                                  <Tag style={{ borderColor: "#008385", color: "#008385", background: "#e6f5f5", fontWeight: 600 }}>Whole Day</Tag>
                                ) : (
                                  <>
                                    <Tag style={{ border: "1px solid #d9d9d9", background: "#fafafa" }}>
                                      {row.startTime ? row.startTime.format("HH:mm") : <span style={{ color: "#bbb" }}>--:--</span>}
                                    </Tag>
                                    <span style={{ color: "#aaa", fontSize: 12 }}>–</span>
                                    <Tag style={{ border: "1px solid #d9d9d9", background: "#fafafa" }}>
                                      {row.endTime ? row.endTime.format("HH:mm") : <span style={{ color: "#bbb" }}>--:--</span>}
                                    </Tag>
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                <DatePicker
                                  style={{ flex: 1, minWidth: 120 }}
                                  value={row.date}
                                  placeholder="Select date"
                                  onChange={(val) => updateCustomDateRow(row.id, "date", val)}
                                  format="DD/MM/YYYY"
                                  size="small"
                                  disabledDate={(current) => current && (current.isBefore(dayjs().startOf('day')) || customDateRanges.some(r => r.id !== row.id && r.date && r.date.isSame(current, 'day')))}
                                />
                                {!row.isWholeDay && (
                                  <>
                                    <TimePicker
                                      style={{ width: 108 }}
                                      value={row.startTime}
                                      placeholder="Start"
                                      format="HH:mm"
                                      onChange={(val) => updateCustomDateRow(row.id, "startTime", val)}
                                      size="small"
                                    />
                                    <span style={{ color: "#aaa", fontSize: 12 }}>–</span>
                                    <TimePicker
                                      style={{ width: 108 }}
                                      value={row.endTime}
                                      placeholder="End"
                                      format="HH:mm"
                                      onChange={(val) => updateCustomDateRow(row.id, "endTime", val)}
                                      size="small"
                                    />
                                  </>
                                )}
                                <Button
                                  size="small"
                                  type={row.isWholeDay ? "primary" : "default"}
                                  onClick={() => updateCustomDateRow(row.id, 'isWholeDay', !row.isWholeDay)}
                                  style={row.isWholeDay
                                    ? { fontSize: 11, backgroundColor: "#008385", borderColor: "#008385", color: "#fff", padding: "0 10px" }
                                    : { fontSize: 11, borderColor: "#008385", color: "#008385", padding: "0 10px" }}
                                >
                                  Whole Day
                                </Button>
                                {customDateRanges.length > 1 && (
                                  <Button
                                    type="text"
                                    size="small"
                                    icon={<DeleteOutlined />}
                                    style={{ color: "#ff4d4f" }}
                                    onClick={() => removeCustomDateRow(row.id)}
                                  />
                                )}
                              </>
                            )}
                          </div>
                        ))}
                      </div>
                      {!isViewMode && (
                        <Button
                          type="dashed"
                          size="small"
                          icon={<PlusOutlined />}
                          onClick={addCustomDateRow}
                          style={{ marginTop: 8, borderColor: "#008385", color: "#008385", width: "100%" }}
                        >
                          Add date
                        </Button>
                      )}
                    </div>
                  )}
                </div>
                )}








                {/* Apply Button */}

                {isViewMode ? (
                  <div style={{ display: "flex", gap: 10, marginTop: 10, alignItems: "center", justifyContent: "center" }}>
                    <Button
                      className="add-generic-btn"
                      style={{
                        borderColor: "#008385",
                        color: "#008385",
                        background: "#fff",
                        fontWeight: 600,
                      }}
                      onClick={() => {
                        setisClinicCreateEnable(false);
                        setshowAddButton(true);
                        setFormMode('edit');
                        resetAvailabilityState();
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="edit-btn-green"
                      icon={<EditOutlined style={{ color: '#fff' }} />}
                      style={{
                        backgroundColor: '#008385',
                        borderColor: '#008385',
                        color: '#fff',
                        fontWeight: 600,
                        minWidth: 90,
                      }}
                      onClick={() => setFormMode('edit')}
                    >
                      Edit
                    </Button>
                  </div>
                ) : (
                  <>
                    <Button
                      type="primary"
                      className="add-generic-btn"
                      style={{
                        marginTop: 10,
                        backgroundColor: "#008385",
                        marginRight: 10,
                      }}
                      onClick={() => {
                        form.setFieldsValue({
                          name: "",
                          price: "",
                          pre_payment_amt: "",
                          cancellations_rescheduling_restrictions: "",
                          min_booking_period_days: "",
                          override_spacers: "",
                          max_wait_slots_between_clinicians: "",
                          clinicians: [],
                          gender_selection: "",
                          language_selection: "",
                          semble_product_id: "",
                        });
                        setPrePayment(false);
                        setEveningBooking(false);
                        setWeekendBooking(false);
                        setGenderSelecttion(false);
                        setLanguageSelection(false);
                        setisClinicCreateEnable(false);
                        setshowAddButton(true);
                        setFormMode('edit');
                        resetAvailabilityState();
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={isSubmitting}
                      disabled={isSubmitting}
                      style={{
                        marginTop: 10,
                        backgroundColor: isSubmitting ? '#80bebe' : '#008385',
                        borderColor: isSubmitting ? '#80bebe' : '#008385',
                        cursor: isSubmitting ? 'not-allowed' : 'pointer',
                      }}
                    >
                      {isSubmitting ? 'Saving...' : 'Save'}
                    </Button>
                  </>
                )}
              </Form>
            )}
          </Card>

          {/* Right Side - Text Areas */}
          {clinicDataSetInUpdate && loader == false && (
            <Card
              className="productcategory-form"
              style={{ width: 600, padding: 5 }}
            >
              {[
                {
                  label: "Product specific booking page long copy - Desktop",
                  name: "product_specific_booking_page_long_copy",
                },
                {
                  label: "Product specific booking page short copy - Mobile",
                  name: "product_specific_booking_page_short_copy",
                },
                {
                  label: "Product specific booking confirmation email copy",
                  name: "specific_booking_confirmation_email_copy",
                },
                {
                  label: "Product specific booking confirmation sms copy",
                  name: "specific_booking_confirmation_sms_copy",
                },
              ].map(({ label, name }, index) => (
                <div
                  key={index}
                  style={{ position: "relative", marginBottom: 15 }}
                >
                  <Form.Item>
                    <div
                      style={{
                        textAlign: "left",
                        alignItems: "flex-start",
                        color: "#4a4a4a",
                        marginBottom: 4,
                        fontSize: 15,
                      }}
                    >
                      {label ===
                      "Product specific booking page long copy - Desktop"
                        ? "Product specific booking page long copy - Desktop"
                        : label ===
                          "Product specific booking page short copy - Mobile"
                        ? "Product specific booking page short copy - Mobile"
                        : label ===
                          "Product specific booking confirmation email copy"
                        ? "Product specific booking confirmation email copy"
                        : label ===
                          "Product specific booking confirmation sms copy"
                        ? "Product specific booking confirmation sms copy"
                        : ""}
                    </div>
                    {isViewMode ? (
                      <div
                        className="emailCopy"
                        dangerouslySetInnerHTML={{
                          __html:
                            label ==
                            "Product specific booking page long copy - Desktop"
                              ? clinicDataSetInUpdate?.product_specific_booking_page_long_copy
                              : label ==
                                "Product specific booking page short copy - Mobile"
                              ? clinicDataSetInUpdate?.product_specific_booking_page_short_copy
                              : label ==
                                "Product specific booking confirmation email copy"
                              ? clinicDataSetInUpdate?.specific_booking_confirmation_email_copy
                              : label ==
                                "Product specific booking confirmation sms copy"
                              ? clinicDataSetInUpdate?.specific_booking_confirmation_sms_copy
                              : "",
                        }}
                      />
                    ) : editTextArea != label && !showEditorOnlyAdd ? (
                      <>
                        <div
                          className="emailCopy"
                          dangerouslySetInnerHTML={{
                            __html:
                              label ==
                              "Product specific booking page long copy - Desktop"
                                ? clinicDataSetInUpdate?.product_specific_booking_page_long_copy
                                : label ==
                                  "Product specific booking page short copy - Mobile"
                                ? clinicDataSetInUpdate?.product_specific_booking_page_short_copy
                                : label ==
                                  "Product specific booking confirmation email copy"
                                ? clinicDataSetInUpdate?.specific_booking_confirmation_email_copy
                                : label ==
                                  "Product specific booking confirmation sms copy"
                                ? clinicDataSetInUpdate?.specific_booking_confirmation_sms_copy
                                : "",
                          }}
                        />
                        <EditOutlined
                          style={{
                            position: "absolute",
                            top: 35,
                            right: 10,
                            fontSize: 18,
                            color: "#999",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            seteditTextArea(label);
                          }}
                        />
                      </>
                    ) : (
                      <Editor
                        apiKey={Config.apiKey}
                        // onInit={(_evt, editor) => editorRef.current = editor}
                        onInit={(_evt, editor) => {
                          editorRef.current = editor;
                          const editorId = editor.id;
                          // Attach a label for char count
                          if (
                            name == "specific_booking_confirmation_sms_copy"
                          ) {
                            editor.on("SkinLoaded", () => {
                              const textOnly =
                                editor.getContent({ format: "text" }) || "";
                              const remaining = Math.max(0, textOnly.length);
                              if (!charCountRefs.current[editorId]) {
                                const label = document.createElement("div");
                                label.style.marginTop = "0";
                                label.style.color = "#aaa";
                                label.style.textAlign = "center";
                                label.innerText = `${
                                  remaining ?? 0
                                }/${MAX_CHARS}`;
                                charCountRefs.current[editorId] = label;
                                const container = editor.getContainer();
                                if (container) {
                                  container.appendChild(label);
                                }
                              }
                            });
                            // Prevent typing beyond limit
                            editor.on("keydown", (e) => {
                              const content = editor.getContent({
                                format: "text",
                              });
                              if (
                                content.length >= MAX_CHARS &&
                                ![8, 46, 37, 38, 39, 40].includes(e.keyCode)
                              ) {
                                e.preventDefault();
                              }
                            });
                          }
                          // ── Teal border on focus / reset on blur ──────────────
                          editor.on('focus', () => {
                            const container = editor.getContainer();
                            if (container) {
                              container.style.border = '1px solid #008385';
                              container.style.boxShadow = '0 0 0 2px rgba(0,131,133,0.15)';
                              container.style.borderRadius = '4px';
                            }
                          });
                          editor.on('blur', () => {
                            const container = editor.getContainer();
                            if (container) {
                              container.style.border = '1px solid #d9d9d9';
                              container.style.boxShadow = 'none';
                            }
                          });
                        }}
                        value={
                          label ==
                          "Product specific booking page long copy - Desktop"
                            ? clinicDataSetInUpdate?.product_specific_booking_page_long_copy
                            : label ==
                              "Product specific booking page short copy - Mobile"
                            ? clinicDataSetInUpdate?.product_specific_booking_page_short_copy
                            : label ==
                              "Product specific booking confirmation email copy"
                            ? clinicDataSetInUpdate?.specific_booking_confirmation_email_copy
                            : label ==
                              "Product specific booking confirmation sms copy"
                            ? clinicDataSetInUpdate?.specific_booking_confirmation_sms_copy
                            : ""
                        }
                        className="productcategoryeditorform"
                        init={{
                          height: 200,
                          width: "100%",
                          // marginTop: 50,
                          menubar: false,
                          plugins: [
                            "advlist",
                            "autolink",
                            "lists",
                            "link",
                            "image",
                            "charmap",
                            "preview",
                            "anchor",
                            "searchreplace",
                            "visualblocks",
                            "code",
                            "fullscreen",
                            "insertdatetime",
                            "media",
                            "table",
                            "code",
                            "help",
                            "wordcount",
                          ],
                          toolbar:
                            label ===
                            "Product specific booking confirmation sms copy"
                              ? "undo redo | blocks |  link | unlink"
                              : "undo redo | blocks | customDropdown | " +
                                "bold italic forecolor | alignleft aligncenter " +
                                "alignright alignjustify | bullist numlist outdent indent | " +
                                "removeformat  " +
                                "link | unlink",
                          setup: (editor) => {
                            customDropdown(editor, "short-codes");
                          },
                          content_style:
                            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                          placeholder:
                            label ===
                            "Product specific booking page long copy - Desktop"
                              ? "Product specific booking page long copy - Desktop"
                              : label ===
                                "Product specific booking page short copy - Mobile"
                              ? "Product specific booking page short copy - Mobile"
                              : label ===
                                "Product specific booking confirmation email copy"
                              ? "Product specific booking confirmation email copy"
                              : label ===
                                "Product specific booking confirmation sms copy"
                              ? "Product specific booking confirmation sms copy"
                              : "",
                        }}
                        onEditorChange={(newContent, editor) => {
                          if (
                            name == "specific_booking_confirmation_sms_copy"
                          ) {
                            const textOnly =
                              editor.getContent({ format: "text" }) || "";
                            const remaining = Math.max(0, textOnly.length);
                            const labelNew = charCountRefs.current[editor.id];
                            if (labelNew) {
                              labelNew.innerText = `${remaining}/${MAX_CHARS}`;
                            }
                            if (textOnly.length > MAX_CHARS) {
                              const trimmed = textOnly.substring(0, MAX_CHARS);
                              editor.setContent(trimmed);
                              // return
                            }
                          }
                          setclinicDataSet((previousData) => {
                            let newData = { ...previousData };
                            if (
                              label ===
                              "Product specific booking page long copy - Desktop"
                            ) {
                              newData.product_specific_booking_page_long_copy =
                                newContent;
                            } else if (
                              label ===
                              "Product specific booking page short copy - Mobile"
                            ) {
                              newData.product_specific_booking_page_short_copy =
                                newContent;
                            } else if (
                              label ===
                              "Product specific booking confirmation email copy"
                            ) {
                              newData.specific_booking_confirmation_email_copy =
                                newContent;
                            } else if (
                              label ===
                              "Product specific booking confirmation sms copy"
                            ) {
                              newData.specific_booking_confirmation_sms_copy =
                                newContent;
                            }
                            return newData;
                          });
                        }}
                      />
                    )}
                  </Form.Item>
                </div>
              ))}
            </Card>
          )}
        </div>
      )}
    </App>
  );
};

export default CorporateProduct;
